import axios from 'axios';

import { API_ENDPOINT, RFID_SERVER_ENDPOINT, URL_ENDPOINT, MKT_BASE_CURRENCY } from '../index';
import { AI_EEZEE_ENDPOINT } from '../../src/index'


axios.interceptors.request.use(function (config) {

	config.params = config.params || {};
	
	// Mkt Base Currency Setup
	config.params.mktBaseCurrency = MKT_BASE_CURRENCY;

	return config;

}, function (error) {
	// Do something with request error
	return Promise.reject(error);
})

export const _getAdmins = () => axios({
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/users`
});

export const _getAds = ({ approved, page, pageSize, searchParam }) => axios({
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/ads?approved=${approved}&page=${page}&pageSize=${pageSize}&searchParam=${searchParam}`
})

export const _getAd = ({ adId }) => axios({
	withCredentials: true,
	url: `${API_ENDPOINT}/api/ads/${adId}`
})

export const _getAllCategories = () => axios({
	withCredentials: true,
	url: `${API_ENDPOINT}/api/category`
});

export const _getAllFlatCategories = () => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/category/flat-categories`
});

export const _getAllBrands = () => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/brands`
});

export const _getCreditNotes = ({ cartId, productOrderId, productOrderStatusId }) => {

	return axios({
		params: {
			cartId,
			productOrderId, 
			productOrderStatusId
		},
		withCredentials:true,
		url: `${API_ENDPOINT}/api/admin/credit-note/`
	});
}

export const _getOpenEnquiries = () => axios({
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/enquiry/open`
});

export const _getEnquiriesBySession = () => axios({
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/enquiry/session`
});

export const _getPermissions = () => axios({
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/permissions`
})

export const _postSearchCreditPayments = ({ searchTerm, page, limit, openOnly, overdueOnly }) => axios({
	withCredentials: true,
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/enterprise/credit-payments`,
	data: {
		searchTerm,
		page,
		limit,
		openOnly,
		overdueOnly
	}
})

export const _postSynonym = ({activeSynonymId, primaryTerm, terms}) => axios({
	withCredentials: true,
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/products/synonym`,
	data: {
		activeSynonymId,
		primaryTerm,
		terms
	}
})

export const _getCreditPayment = (paymentId) => axios({
	withCredentials: true,
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/enterprise/credit-payment/${paymentId}`
})

export const _getCreditData = (enterpriseId) => axios({
	withCredentials: true,
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/enterprise/credit/${enterpriseId}`
})

export const _getAllBanners = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/banners`,
	withCredentials: true
})

export const _getAdditionalChargeHoldingList = ({ cartId }) => axios({
	method: "get",
	url: `${API_ENDPOINT}/api/admin/holding-list/additional-charge/${cartId}`,
	withCredentials: true
});

export const _getAdditionalChargeReasons = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/orders/additional-charge/reason`,
	withCredentials: true
})

export const _getDocCategories = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/docs/categories`,
	withCredentials: true
})

export const _getDoc = (docId) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/docs/${docId}`,
	withCredentials: true
})

export const _getDocs = ({page, limit, searchTerm}) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/docs`,
	withCredentials: true,
	params: {
		page,
		limit,
		searchTerm
	}
})

export const _getBugs = ({ page, limit, searchTerm, filterClosed = false }) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/bugs?page=${page}&limit=${limit}&s=${searchTerm}`,
	withCredentials: true
})

export const _getBug = (bugId) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/bugs/${bugId}`,
	withCredentials: true
})

export const _getBugLogs = ({ bugId, page, limit }) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/bugs/logs/${bugId}`,
	withCredentials: true,
	params: {
		page,
		limit
	}
})

export const _postBugLog = ({ bugId, message, action }) => axios({
	method: 'post',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/bugs/logs/${bugId}`,
	data: {
		message,
		action
	}
})

export const _getCart = (cartId) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/cart/${cartId}`
})

export const _getCartByReference = (refNumber) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/cart/reference/${refNumber}`
})

export const _getCartByOfflineReferenceNumber = (offlineReferenceNumber) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/cart/offline/${offlineReferenceNumber}`
})

export const _getCategory = (categoryId) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/category/${categoryId}`
})

export const _getCategoryByTitleUrl = (titleUrl) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/category/${titleUrl}/title-url`
})

export const _getCategoryFeature = ({ categoryFeatureId }) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/category-feature/${categoryFeatureId}`
})

export const _getCategoryFeatures = ({ searchParam, pageSize, current }) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/category-feature`
})

export const _getCategorySpecHeaders = (subKebabCase) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/category/list-headers/${subKebabCase}`
})


export const _getCategorySpecTemplate = (subKebabCase) => axios({
	url: `${API_ENDPOINT}/api/admin/category/${subKebabCase}/category-spec-templates`,
	withCredentials: true,
	method: 'get'
})

export const _getCategorySpecTable = (subKebabCase) => axios({
	url: `${API_ENDPOINT}/api/category/${subKebabCase}/spec-table?preview=true`,
	withCredentials: true,
	method: 'get'
})

export const _getCategorySpecTableSortingRules = (subKebabCase) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/category/${subKebabCase}/category-spec-table-sorting-rules`
})

export const _getCheckGdToken = () => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/order-docs/check-token`
})

export const _getCheckQbToken = () => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/quickbooks/check-token`
})

export const _getCustomerJourney = (cartId) => axios({
	method: 'get',
	withCredentials: true,
	url: `${AI_EEZEE_ENDPOINT}/customerjourney?id=${cartId}`
})

export const _getDataReport = (dataReportId) => axios({
	method: "get",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/data-report/${dataReportId}`
})

export const _downloadDataReport = ({dataReportId}) => axios({
	method: "get",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/data-report/process/${dataReportId}`
})

export const _getDataReports = ({searchTerm}) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/data-report`,
	params: {
		searchTerm
	}
});

export const _postDataReportDownloads = ({page, limit}) => axios({
	method: 'post',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/data-report/data-report-history`,
	data: {
		page,
		limit
	}
})

export const _getElasticSearchProducts = ({ searchParam, limit, withVariants }) => axios({
	withCredentials: true,
	url: `${API_ENDPOINT}/api/products/query`,
	params: {
		searchParam, 
		limit,
		withVariants
	}
});

export const _getSearchProducts = ({ searchParam, limit }) => axios({
	withCredentials: true,
	url: `${API_ENDPOINT}/api/supplier/product/search/1`,
	params: {
		searchParam, 
		limit,
		activeOnly: false
	}
});

export const _getSearchAdmins = ({ searchParam, limit }) => axios({
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/users/admin/search/1`,
	params: {
		searchParam, 
		limit,
	}
});

export const _getEnterpriseContracts = ({searchTerm, page, limit}) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/enterprise/contracts`,
	params: {
		searchTerm,
		page,
		limit
	}
})

export const _getEnterpriseData = (enterpriseId) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/enterprise/${enterpriseId}`
})

export const _getEnterpriseUomReferences = () => axios({
	method: "get",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/enterprise/uom-references`
});

export const _getEnterpriseOciPunchoutCredentials = ( enterpriseId ) => axios({
	method: "get",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/enterprise/oci-punchout-credentials`,
	params: {
		enterpriseId
	}
});

export const _getEnterpriseRtb = ({ page, pageSize }) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/enterprise/rtb?page=${page}&pageSize=${pageSize}`
});

export const _getEnterpriseUsers = ({ enterpriseId, page, limit, searchTerm }) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/enterprise/users/${enterpriseId}?page=${page}&limit=${limit}&searchTerm=${searchTerm}`
})

export const _getGoogleDriveAuthUrl = () => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/order-docs/get-auth-url`
})

export const _getGoogleTaxonomies = () => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/products/google-product-taxonomies`
});

export const _getSearchBrands = (searchTerm) => axios({
	url: `${API_ENDPOINT}/api/brands/search/${searchTerm}`,
	method: 'get',
	withCredentials: true
})

export const _getSearchMainCat = (searchTerm) => axios({
	url: `${API_ENDPOINT}/api/category/main/search/${searchTerm}`,
	method: 'get',
	withCredentials: true
})

export const _getSearchSubCat = (searchTerm) => axios({
	url: `${API_ENDPOINT}/api/category/sub/search/${searchTerm}`,
	method: 'get',
	withCredentials: true
})

export const _getSearchDeliveries = (searchParams) => axios({
	url: `${API_ENDPOINT}/api/delivery/search/${searchParams}`,
	method: 'get',
	withCredentials: true
})

export const _getSearchEnterprise = ({ searchTerm, page = 1, limit }) => axios({
	url: `${API_ENDPOINT}/api/admin/enterprise/search/?searchTerm=${searchTerm}&page=${page}&limit=${limit}`,
	method: 'get',
	withCredentials: true
});

export const _getSearchOrders = (searchTerm) => axios({
	url: `${API_ENDPOINT}/api/admin/orders/search/${searchTerm}`,
	method: 'get',
	withCredentials: true
})

export const _getSearchSupplier = (searchTerm) => axios({
	url: `${API_ENDPOINT}/api/admin/supplier/search/${searchTerm}`,
	method: 'get',
	withCredentials: true
})

export const _getSearchUser = (searchTerm, page = 1) => axios({
	url: `${API_ENDPOINT}/api/admin/users/search/${searchTerm}/${page}`,
	method: 'get',
	withCredentials: true
})

export const _getSizeOfOrdersInProgress = () => axios({
	url: `${API_ENDPOINT}/api/admin/orders/in-progress-size`,
	method: 'get',
	withCredentials: true
})

export const _getSupplierAddress = ({ supplierId }) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/supplier/get-address/${supplierId}`
})

export const _getSupplierEmails = (reason) => axios({
	method: 'get',
	responseType: 'blob',
	url: `${API_ENDPOINT}/api/admin/supplier/emails/${reason}`,
	withCredentials: true,
})

export const _getSupplierName = (supplierId) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/supplier/get-name/${supplierId}`
})

export const _getSupplierInformation = (supplierId) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/supplier/${supplierId}`
})

export const _getSuppliersDetails = (cartId) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/orders/${cartId}/get-suppliers-details`
})

export const _getSynonyms = ({ searchParam, page, limit }) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/products/synonym`,
	params: {
		searchParam,
		page,
		limit
	}
})

export const _getSynonymSuggestion = (term) => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/products/synonym/suggest`,
	params: {
		term
	}
})

export const _postGetTagsFromEezeeServer = ( tagIds ) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/products/tags`,
	data: {
		tagIds
	}
});

export const _getUnitsOfMeasurements = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/units`
});

export const _getUserEmails = (reason) => axios({
	method: 'get',
	responseType: 'blob',
	url: `${API_ENDPOINT}/api/admin/users/emails/all/${reason}`,
	withCredentials: true,
})

export const _getUser = (userId) => axios({
	withCredentials: true,
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/users/${userId}`
})

export const _getUsers = (page = 1) => axios({
	withCredentials: true,
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/users/list/${page}`
})

export const _getCategoryMainStats = () => axios({
	url: `${API_ENDPOINT}/api/admin/category/stats/`,
	method: 'get',
	withCredentials: true
})

export const _getCategorySubStats = (mainKebabCase) => axios({
	url: `${API_ENDPOINT}/api/admin/category/stats/${mainKebabCase}`,
	method: 'get',
	withCredentials: true
})

export const _getClaimOrder = (orderId) => axios({
	url: `${API_ENDPOINT}/api/admin/orders/claim/${orderId}`,
	method: 'get',
	withCredentials: true
})

export const _getOneMapApi = (postalCode) => axios({
	url: `https://developers.onemap.sg/commonapi/search?searchVal=${postalCode}&returnGeom=Y&getAddrDetails=Y&pageNum=1`,
	method: 'get'
})

export const _getOrderStatus = ({ cartId, orderStatusId }) => {

	if( !cartId && !orderStatusId ){
		throw "Either cartId or orderStatusId is required!";
	}

	if( cartId ){
		return axios({
			withCredentials: true,
			method: "get",
			url: `${API_ENDPOINT}/api/admin/order-status/cart-id/${cartId}`
		});
	}

	if( orderStatusId ){
		return axios({
			withCredentials: true,
			method: "get",
			url: `${API_ENDPOINT}/api/admin/order-status/${orderStatusId}`
		});
	}

}

export const _getOrderStatuses = ({enterpriseId}) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/credit/order-status`,
	withCredentials: true,
	params: {
		enterpriseId
	}
})

export const _deleteCategoryFeature = (categoryFeatureId) => axios({
	url: `${API_ENDPOINT}/api/admin/category-feature/${categoryFeatureId}`,
	method: 'delete',
	withCredentials: true
})

export const _deleteEnterpriseOciPunchoutCredentials = ( ociPunchoutCredentialsId ) => axios({
	withCredentials: true,
	method: "delete",
	url: `${API_ENDPOINT}/api/admin/enterprise/oci-punchout-credential/${ociPunchoutCredentialsId}`
});

export const _deleteIotDevice = ( iotDeviceId ) => axios({
	method: "delete",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/iot-devices/${iotDeviceId}`
});

export const _getOrders = ({
	shipping,
	paymentMethod,
	country,
	fromDate,
	toDate,
	inProgress,
	unclaimed,
	myOrder,
	awaitingPayment,
	voided,
	deliveryNot,
	page = 1,
	queryMode
}) => axios({
	url: `${API_ENDPOINT}/api/admin/orders/query`,
	method: 'post',
	withCredentials: true,
	data: {
		shipping,
		paymentMethod,
		country,
		fromDate,
		toDate,
		inProgress,
		unclaimed,
		myOrder,
		awaitingPayment,
		voided,
		deliveryNot,
		page,
		queryMode
	}
})

export const _getSearchCheckedoutOrdersUniversal = ({
	shipping,
	paymentMethod,
	country,
	fromDate,
	toDate,
	inProgress,
	unclaimed,
	myOrder,
	awaitingPayment,
	voided,
	deliveryNot,
	page = 1,
	queryMode,
	searchTerm,
	limit
}) => axios({
	url: `${API_ENDPOINT}/api/admin/orders/search-universal`,
	method: 'post',
	withCredentials: true,
	data: {
		shipping,
		paymentMethod,
		country,
		fromDate,
		toDate,
		inProgress,
		unclaimed,
		myOrder,
		awaitingPayment,
		voided,
		deliveryNot,
		page,
		queryMode,

		searchTerm,
		limit
	}
})

export const _getOrderData = (orderId) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/orders/single/${orderId}`,
	withCredentials: true
})

export const _getQbPaymentMethods = () => axios({
	withCredentials: true,
	method: "get",
	url: `${API_ENDPOINT}/api/admin/quickbooks/paymentMethods`
})


// export const _getAllUncompletedDeliveriesAndPickups = ([startDate, endDate]) => axios({
// 	withCredentials: true,
// 	method: "get",
// 	url: `${API_ENDPOINT}/api/admin/delivery/`,
// 	params:{ 
// 		start: startDate,
// 		end: endDate
// 	}
// })

export const _tckEndpoint= (idArray) => axios({
	withCredentials: true,
	method: "post",
	url: `${API_ENDPOINT}/api/admin/delivery/check-tck-status`,
	data: {
		idArray:idArray
	}
})

export const _getDeliveriesWithFilter = ({ dateRangeArray, showWeekends }) => axios({
	withCredentials: true,
	method: "post",
	url: `${API_ENDPOINT}/api/admin/delivery/filter`,
	data: {
		start: dateRangeArray[0],
		end: dateRangeArray[1],
		showWeekends: showWeekends
	}
})

export const _lockLocations = ( locationsIds,userName,userEmail,userId ) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/delivery/lock-locations`,
	data: {
		locationIds: locationsIds,
		userName,
		userEmail,
		userId,
	},
	withCredentials: true
});

export const _deleteProducts = ({locationId, productOrderStatusIdArray, deleteWhole}) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/delivery/delete-delivery`,
	data: {
		locationId,
		productOrderStatusIdArray,
		deleteWhole
	},
	withCredentials: true
})

export const _deletePermission = (permissionId) => axios({
	method: 'delete',
	url: `${API_ENDPOINT}/api/admin/permissions/${permissionId}`,
	withCredentials: true
})

export const _deleteSynonym = (synonymId) => axios({
	method: 'delete',
	url: `${API_ENDPOINT}/api/admin/products/synonym/${synonymId}`,
	withCredentials: true
})

export const _searchScheduler = ({search, start, end, showWeekends}) => axios({
	withCredentials: true,
	method: "post",
	url: `${API_ENDPOINT}/api/admin/delivery/search`,
	data:{
		searchTerm: search,
		start,
		end,
		showWeekends
	}
})

export const _downloadJobPdfs = ({date, deliveryMode, locationActionRequired, selectedLocations}) => axios({
	withCredentials: true,
	method: "post",
	url: `${API_ENDPOINT}/api/admin/delivery/do`,
	data:{
		date,
		deliveryMode,
		mktBaseCurrency: MKT_BASE_CURRENCY,
		locationActionRequired,
		locationIds: selectedLocations
	},
	responseType: "arraybuffer"
})

export const _changeProductSpecificDateScheduled = ({ deliveryLocationId, productIdArray, dateChange }) => axios({
	withCredentials: true,
	method: "post",
	url: `${API_ENDPOINT}/api/admin/delivery/change-product-specific-date`,
	data: {
		deliveryLocationId,
		productIdArray,
		dateChange
	}
})
export const _createTckPickup = ({locationId, productIdArray, deliveryMode}) =>  axios({
	withCredentials: true,
	method: "post",
	url: `${API_ENDPOINT}/api/admin/delivery/create-tck-pickup`,
	data:{
		locationId, 
		productIdArray,
		deliveryMode
	}
})
export const _postNewDeliveryMode = (deliveryMode ,locationIdArray, supplierSendId,userName,userEmail,userId) => axios({
	withCredentials: true,
	method: "post",
	url: `${API_ENDPOINT}/api/admin/delivery/change-delivery-mode`,
	data: {
		deliveryMode: deliveryMode,
		locationIdArray: locationIdArray,
		supplierSendId,
		userName,
		userEmail,
		userId,
	}
})
export const _postNewDateScheduled = (date, locationIdArray , userName , userId, userEmail) => axios({
	withCredentials: true,
	method: "post",
	url: `${API_ENDPOINT}/api/admin/delivery/change-date-scheduled`,
	data: {
		date: date,
		locationIdArray: locationIdArray,
		userName,
		userId,
		userEmail
	}
})

export const _postAdminPermission = ({ title, pages, permissionId = false }) => axios({
	withCredentials: true,
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/permissions`,
	data: {
		title,
		pages,
		permissionId
	}
})

export const _schedulerLogs = (searchTerm) => axios({
	withCredentials: true,
	method: "post",
	url: `${API_ENDPOINT}/api/admin/delivery/delivery-scheduler-logs`,
	data: {
		searchTerm
	}
	
})
export const _postNewAddress = ({ locationId, companyName, name, hp, address, postalCode, unit, userName,userEmail,userId}) => axios({
	withCredentials: true,
	method: "post",
	url: `${API_ENDPOINT}/api/admin/delivery/edit-address`,
	data: {
		locationId,
		companyName,
		name,
		hp,
		address,
		postalCode,
		unit,
		userName,
		userEmail,
		userId,
	}
})
export const _getQbDepositToAccounts = () => axios({
	withCredentials: true,
	method: "get",
	url: `${API_ENDPOINT}/api/admin/quickbooks/depositToAccounts`
})

export const _getQbExpenseAccounts = () => axios({
	withCredentials: true,
	method: "get",
	url: `${API_ENDPOINT}/api/admin/quickbooks/expenseAccounts`
})

export const _getPieChartData = ({ method = "get", url }) => axios({
	method,
	url,
	withCredentials: true
});


export const _getPiLink = (fileName) => axios({
	method: "get",
	url: `${API_ENDPOINT}/api/admin/order-docs/get-pi/${fileName}`,
	withCredentials: true
})

export const _getPingRfidServer = () => axios({
	method: "get",
	url: `${RFID_SERVER_ENDPOINT}/ping`
});

export const _getProductLogs = ({startDate, endDate, actionFilter}) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/products/changes/logs`,
	withCredentials: true,
	params: {
		startDate,
		endDate,
		actionFilter
	}
})

export const _getProductPriceFlags = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/products/changes/flags`,
	withCredentials: true,
})

export const _getProductsInStockToday = () => axios({
	method: "get",
	url: `${API_ENDPOINT}/api/admin/orders/in-stock-today`,
	withCredentials: true
});

export const _getProductsToUpdate = () => axios({
	method: "get",
	url: `${API_ENDPOINT}/api/admin/products/todo`,
	withCredentials: true
});

export const _getStockIntegrations = ({page, limit}) => axios({
	withCredentials: true,
	url: `${API_ENDPOINT}/api/stock-integration`,
	params: {
		page,
		limit
	}
})

export const _getStockIntegration = ({supplierId}) => axios({
	withCredentials: true,
	url: `${API_ENDPOINT}/api/stock-integration/${supplierId}`
})

export const _getStockIntegrationUpdateHistories = ({page, limit, supplierId}) => axios({
	withCredentials: true,
	url: `${API_ENDPOINT}/api/stock-integration/update-history/${supplierId}`,
	params: {
		page,
		limit
	}
})

export const _getSearchCompanyRecords = (searchParam, options) => axios({
	method: "get",
	url: `${API_ENDPOINT}/api/company-records/search?q=${searchParam}`,
	withCredentials: true,
	...options
});

export const _getSearchUserEmails = (searchParam, limit = 40) => axios({
	url: `${API_ENDPOINT}/api/admin/users/search/${searchParam}?limit=${limit}`,
	withCredentials: true,
	method: 'get'
});

export const _getTodaysOrdersCount = () => axios({
	url: `${API_ENDPOINT}/api/admin/orders/get-todays-orders-count/`,
	withCredentials: true,
	method: 'get'
})

export const _getMassUploadBatch = (massUploadId) => axios({
	method: "get",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/mass-upload-batch/${massUploadId}`
});

export const _getMyHoldingList = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/holding-list/`,
	withCredentials: true
});

export const _getQbCustomers = (pageNumber, searchTerm) => axios({
	url: `${API_ENDPOINT}/api/admin/quickbooks/get-users/${pageNumber}/${searchTerm}`,
	withCredentials: true,
	method: "get"
})

export const _getQbTerms = () => axios({
	withCredentials: true,
	method: "get",
	url: `${API_ENDPOINT}/api/admin/quickbooks/terms`
})

export const _getQuotation = (_id) => axios({
	url: `${API_ENDPOINT}/api/admin/orders/single/${_id}`,
	withCredentials: true,
	method: "get"
})


export const _getQuotations = ({
	draft = false,
	page = 1,
	userId = false,
	searchTerm = false
}) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/quotation${userId ? `/${userId}` : ''}?page=${page}${draft ? '&draft=true' : ''}${searchTerm ? `&searchTerm=${searchTerm}` : ''}`,
	withCredentials: true
});

export const _getLeafPages = () => axios({
	method: "get",
	url: `${API_ENDPOINT}/api/leaf-page`
})

export const _getEezeePaymentDetails = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/enterprise/eezee-payment-details`,
	withCredentials: true,
})

// POSTS
export const _postAddAddressToQuote = ({ userId, address, quotationId }) => axios({
	url: `${API_ENDPOINT}/api/admin/quotation/${quotationId}/address/${userId}`,
	data: address,
	method: 'post',
	withCredentials: true
})

export const _postAddEmptyCustomProductToHoldingList = ({ holdingListId }) => axios({
	url: `${API_ENDPOINT}/api/admin/holding-list/add-custom-product/${holdingListId}`,
	method: 'post',
	withCredentials: true
})

export const _postAddCustomProduct = (productTitle) => axios({
	url: `${API_ENDPOINT}/api/admin/custom-product`,
	method: 'post',
	withCredentials: true,
	data: {
		productTitle
	}
})

export const _postAddCcEmail = ({enterpriseId, email, key}) => axios({
	url: `${API_ENDPOINT}/api/admin/enterprise/cc-email/${enterpriseId}`,
	data: {
		email,
		key
	},
	method: 'post',
	withCredentials: true
})

export const _postAddProductToHoldingList = (holdingListId, product) => axios({
	url: `${API_ENDPOINT}/api/admin/holding-list/add-product/${holdingListId}`,
	withCredentials: true,
	method: 'post',
	data: {
		product
	}
})

export const _postApproveAd = ({ adId }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/ads/approve/${adId}`,
	withCredentials: true
});



export const _postGenerateRfidTag = ({ quantity, productId, variantSetIds }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/products/${productId}/generate-rfid-tag`,
	data: {
		quantity,
		variantSetIds
	},
	withCredentials: true
});

export const _postTerminateAd = ({ adId }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/ads/terminate/${adId}`,
	withCredentials: true,
})


export const _postPauseAd = ({ adId }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/ads/pause/${adId}`,
	withCredentials: true,
})

export const _postAdStatus = ({ adId, status }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/ads/status/${adId}`,
	withCredentials: true,
	data: {
		status
	}
});

export const _postApproveManualPayment = ({ cartId, instantInvoice }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/orders/toggle-order-paid-manual`,
	data: {
		cartId,
		instantInvoice
	},
	withCredentials: true
});
export const _postRejectedGoods = ({rejectedGoods, deliveryLocationId})=> axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/delivery/reject-goods`,
	data: {
		rejectedGoods,
		deliveryLocationId
	},
	withCredentials: true
});

export const _postAssignUserToQuotation = ({ quotationId, userId }) => axios({
	url: `${API_ENDPOINT}/api/admin/quotation/${quotationId}/assign-user/${userId}`,
	method: "post",
	withCredentials: true,
})

export const _postCancelQuote = (cartId) => axios({
	url: `${API_ENDPOINT}/api/admin/quotation/${cartId}/cancel`,
	method: "post",
	withCredentials: true
})

export const _postToggleCategoryFeatureActive = ({ categoryFeatureId }) => axios({
	url: `${API_ENDPOINT}/api/admin/category-feature/${categoryFeatureId}/toggle-active`,
	withCredentials: true,
	method: 'post'
})

export const _postCategoryFeature = () => axios({
	url: `${API_ENDPOINT}/api/admin/category-feature`,
	withCredentials: true,
	method: 'post'
})

export const _postCategoryIndexSpecTableData = (subKebabCase) => axios({
	url: `${API_ENDPOINT}/api/admin/category/${subKebabCase}/category-index-spec-table`,
	withCredentials: true,
	method: 'post'
})

export const _postCategorySpecHeaderTemplate = ({ subKebabCase, data }) => axios({
	url: `${API_ENDPOINT}/api/admin/category/${subKebabCase}/category-spec-header`,
	withCredentials: true,
	method: 'post',
	data: {
		data
	}
})

export const _postCategorySpecTableSortingRules = ({ subKebabCase, sortingRules }) => axios({
	url: `${API_ENDPOINT}/api/admin/category/${subKebabCase}/category-spec-table-sorting-rules`,
	withCredentials: true,
	method: 'post',
	data: {
		sortingRules
	}
})

export const _postCategorySpecTableTemplate = ({ subKebabCase, data }) => axios({
	url: `${API_ENDPOINT}/api/admin/category/${subKebabCase}/category-spec-table`,
	withCredentials: true,
	method: 'post',
	data: {
		data
	}
})

export const _postCategorySpecType = ({ subKebabCase, specType }) => axios({
	url: `${API_ENDPOINT}/api/admin/category/${subKebabCase}/category-spec-type`,
	withCredentials: true,
	method: 'post',
	data: {
		specType
	}
});

export const _postChangeQuotationPoRefNumber = (quotationId, poRefNumber: string) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/quotation/${quotationId}/po-ref-number`,
	withCredentials: true,
	data: {
		poRefNumber
	}
})

export const _postChangeWebViewLink = ({ type, id, webViewLink, orderId }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/orders/${orderId}/change-web-view-link`,
	withCredentials: true,
	data: {
		type,
		id,
		webViewLink
	}
})

export const _postCheckIfEmailExist = (email) => axios({
	url: `${API_ENDPOINT}/api/user/check/email`,
	method: 'post',
	data: {
		email
	},
	withCredentials: true,
})

export const _postCheckValidCart = (refNumber) => axios({
	url: `${API_ENDPOINT}/api/cart/ref-number/${refNumber}`,
	withCredentials: true,
	method: 'post'
})

export const _postCloseEnquiry = (enquiryId) => axios({
	url: `${API_ENDPOINT}/api/admin/enquiry/close/${enquiryId}`,
	withCredentials: true,
	method: 'post'
})



export const _postConfirmAdditionalCharge = ({ holdingListId }) => axios({
	url: `${API_ENDPOINT}/api/admin/orders/confirm-additional-charge`,
	withCredentials: true,
	method: 'post',
	data: {
		holdingListId
	}
})

export const _postConvertToHoldingList = ({ name, productOrders }) => axios({
	url: `${API_ENDPOINT}/api/admin/enquiry/convert-to-holding-list`,
	withCredentials: true,
	method: 'post',
	data: {
		name,
		productOrders
	}
})

export const _postReassignBug = (bugId, email, reason) => axios({
	url: `${API_ENDPOINT}/api/bugs/reassign/${bugId}`,
	withCredentials: true,
	method: 'post',
	data: {
		email,
		reason
	}
});

export const _postClaimBug = (bugId) => axios({
	url: `${API_ENDPOINT}/api/bugs/claim/${bugId}`,
	withCredentials: true,
	method: 'post',
});

export const _postCloseBug = (bugId, reason) => axios({
	url: `${API_ENDPOINT}/api/bugs/close/${bugId}`,
	withCredentials: true,
	method: 'post',
	data: {
		reason
	}
});

export const _postSubmitBugComment = ({ bugId, comment, parent }) => axios({
	url: `${API_ENDPOINT}/api/bugs/comment/${bugId}`,
	withCredentials: true,
	method: 'post',
	data: {
		comment,
		parent
	}
});

export const _paginateSlaDiscprencies = ({
	page, 
	limit,
	offlineReferenceNumber_search,
	fdTicketNum_search,
	supplierCompanyName_search,
	enterpriseCompanyName_search
}) => axios({
	url: `${API_ENDPOINT}/api/admin/sla-discrepencies/paginate`,
	withCredentials: true,
	method: 'post',
	data: {
		page, 
		limit,
		offlineReferenceNumber_search,
		fdTicketNum_search,
		supplierCompanyName_search,
		enterpriseCompanyName_search
	}
})

export const _updateSlaDiscrepency = ({ slaId, data, reason, remarks, responsibility }) => axios({
	url: `${API_ENDPOINT}/api/admin/sla-discrepencies/update`,
	withCredentials: true,
	method: 'post',
	data: {
		slaId,
		data,
		reason,
		remarks,
		responsibility
	}
});

export const _postSlaDiscrepency = ({ data, reason, remarks, responsibility }) => axios({
	url: `${API_ENDPOINT}/api/admin/sla-discrepencies/new`,
	withCredentials: true,
	method: 'post',
	data: {
		data,
		reason,
		remarks,
		responsibility
	}
});

export const _getSlaDiscrepency = ({ slaId }) => axios({
	url: `${API_ENDPOINT}/api/admin/sla-discrepencies/${slaId}`,
	withCredentials: true,
	method: 'get',
});

export const _deleteSla = ({ slaId }) => axios({
	url: `${API_ENDPOINT}/api/admin/sla-discrepencies/${slaId}`,
	withCredentials: true,
	method: 'delete',
});

export const _postReopenBug = ({bugId, reason}) => axios({
	url: `${API_ENDPOINT}/api/bugs/reopen/${bugId}`,
	withCredentials: true,
	method: 'post',
	data: {
		reason
	}
});

export const _postEditCategoryFeature = (categoryFeature) => axios({
	url: `${API_ENDPOINT}/api/admin/category-feature/${categoryFeature._id}/edit`,
	withCredentials: true,
	method: 'post',
	data: categoryFeature
})

export const _postUpdateCategoryFeature = ({categoryFeatureId, key, value}) => axios({
	url: `${API_ENDPOINT}/api/admin/category-feature/${categoryFeatureId}/update`,
	withCredentials: true,
	method: 'post',
	data: {
		key,
		value
	}
})

export const _postEditDocCategory = ({editKey, docCategoryId, value}) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/category/edit/${docCategoryId}`,
	withCredentials: true,
	method: 'post',
	data: {
		editKey,
		value
	}
})

export const _postEditDocSubCategory = ({editKey, docSubCategoryId, value}) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/category/edit-sub/${docSubCategoryId}`,
	withCredentials: true,
	method: 'post',
	data: {
		editKey,
		value
	}
})

export const _postEditIotDevice = ({ enterpriseId, _id, deviceName, deviceType }) => axios({
	url: `${API_ENDPOINT}/api/admin/iot-devices/${_id}`,
	method: "post",
	withCredentials: true,
	data: { 
		enterpriseId, 
		_id, 
		deviceName, 
		deviceType
	}
})

export const _postEditBug = ({ bugId, severity, url, description, reportedByEmail, imageUrl, type }) => axios({
	url: `${API_ENDPOINT}/api/bugs/edit/${bugId}`,
	withCredentials: true,
	method: 'post',
	data: {
		severity,
		url,
		description,
		reportedByEmail,
		imageUrl,
		type
	}
});

export const _postAddDocTag = ({docId, tag}) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/add-tag/${docId}`,
	withCredentials: true,
	method: 'post',
	data: {
		tag
	}
})

export const _postRemoveCcEmail = ({enterpriseId, email, key}) => axios({
	url: `${API_ENDPOINT}/api/admin/enterprise/remove-cc-email/${enterpriseId}`,
	data: {
		email,
		key
	},
	method: 'post',
	withCredentials: true
})

export const _postRemoveDocCategory = (docCategoryId) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/category/remove/${docCategoryId}`,
	withCredentials: true,
	method: 'post'
})

export const _postRemoveDocSubCategory = ({docCategoryId, docSubCategoryId}) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/category/remove-sub/${docCategoryId}/${docSubCategoryId}`,
	withCredentials: true,
	method: 'post'
})

export const _postRemoveDocTag = ({docId, tag}) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/remove-tag/${docId}`,
	withCredentials: true,
	method: 'post',
	data: {
		tag
	}
})

export const _postAddDocSubCategory = ({subTitle, docCategoryId}) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/category/add-sub/${docCategoryId}`,
	withCredentials: true,
	method: 'post',
	data: {
		subTitle
	}
})

export const _postNewDoc = ({title, excerpt, text}) => axios({
	url: `${API_ENDPOINT}/api/admin/docs`,
	withCredentials: true,
	method: 'post',
	data: {
		title,
		excerpt,
		text
	}
})

export const _postNewDocCategory = (mainTitle) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/category/new`,
	withCredentials: true,
	method: 'post',
	data: {
		mainTitle
	}
})

export const _postNewStockIntegration = ({
	supplierId,
	integrationType,
	identifierType,
	identifierColumn,
	quantityColumn,
	timestampColumn,
	rowStart,
	timestampFormat,
	updateSchedule,
	fileEndpoint,
	incomingEmailAddresses,
	doNotNotifyFlag
}) => axios({
	url: `${API_ENDPOINT}/api/stock-integration`,
	withCredentials: true,
	method: 'post',
	data: {
		supplierId,
		integrationType,
		identifierType,
		identifierColumn,
		quantityColumn,
		timestampColumn,
		rowStart,
		timestampFormat,
		updateSchedule,
		fileEndpoint,
		incomingEmailAddresses,
		doNotNotifyFlag
	}
})

export const _postEditStockIntegration = ({
	supplierId,
	integrationType,
	identifierType,
	identifierColumn,
	quantityColumn,
	timestampColumn,
	rowStart,
	timestampFormat,
	updateSchedule,
	fileEndpoint,
	incomingEmailAddresses,
	doNotNotifyFlag
}) => axios({
	url: `${API_ENDPOINT}/api/stock-integration/${supplierId}`,
	withCredentials: true,
	method: 'put',
	data: {
		integrationType,
		identifierType,
		identifierColumn,
		quantityColumn,
		timestampColumn,
		rowStart,
		timestampFormat,
		updateSchedule,
		fileEndpoint,
		incomingEmailAddresses,
		doNotNotifyFlag
	}
})



export const _postCreateBug = ({ severity, url, description, reportedByEmail, imageUrl, type}) => axios({
	url: `${API_ENDPOINT}/api/bugs`,
	withCredentials: true,
	method: 'post',
	data: {
		severity,
		url,
		description,
		reportedByEmail,
		imageUrl,
		type
	}
});


export const _sendBugUpdateEmailToUser = ({ message, bugId }) => axios({
	method: 'post',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/bugs/email-user`,
	data: {
		message,
		bugId,
	}
})

export const _postCreateEmptyQuotation = () => axios({
	url: `${API_ENDPOINT}/api/admin/quotation`,
	withCredentials: true,
	method: 'post'
});

export const _postCreateCreditPayment = ({ toDate, enterpriseId }) => axios({
	url: `${API_ENDPOINT}/api/admin/enterprise/credit-payment`,
	withCredentials: true,
	method: 'post',
	data: {
		toDate,
		enterpriseId
	}
});

export const _postSettleCreditPayment = ({ paymentId, batch }) => axios({
	url: `${API_ENDPOINT}/api/admin/enterprise/credit-payment/settle/${paymentId}`,
	withCredentials: true,
	method: 'post',
	data: {
		batch
	}
});

export const _postSetFakeOrder = ({ cartId }) => axios({
	url: `${API_ENDPOINT}/api/admin/orders/set-as-fake-order/${cartId}`,
	withCredentials: true,
	method: 'post',
});

export const _postCreditPaymentSent = ({ paymentId, dateSent }) => axios({
	url: `${API_ENDPOINT}/api/admin/enterprise/credit-payment/sent/${paymentId}`,
	withCredentials: true,
	method: 'post',
	data: {
		dateSent
	}
});

export const _postCreditPaymentDelete = ({ paymentId }) => axios({
	url: `${API_ENDPOINT}/api/admin/enterprise/credit-payment/delete/${paymentId}`,
	withCredentials: true,
	method: 'post',
});



export const _postSetEnterpriseModuleTier = ({ enterpriseId, tier, modules }) => axios({
	url: `${API_ENDPOINT}/api/admin/enterprise/set-module-tier/${enterpriseId}`,
	withCredentials: true,
	method: 'post',
	data: {
		modules,
		tier
	}
});

export const _postToggleCreditPaymentDNS = ({ paymentId, userId }) => axios({
	url: `${API_ENDPOINT}/api/admin/enterprise/credit-payment/toggle-dns/${paymentId}`,
	withCredentials: true,
	method: 'post',
	data: {
		notifiedUserId: userId
	}
});

export const _postToggleModule = ({ enterpriseId, moduleKey }) => axios({
	url: `${API_ENDPOINT}/api/admin/enterprise/toggle-module/${enterpriseId}`,
	withCredentials: true,
	method: 'post',
	data: {
		moduleKey
	}
});

export const _postInviteUserToEnterprise = ({ enterpriseId, email, sendInvite }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/enterprise/invite-user`,
	withCredentials: true,
	data: {
		enterpriseId,
		email,
		sendInvite
	}
});

export const _postAddInternationalShippingInfo = ({ cartId, incoterms, netWeight, grossWeight, dimension, totalBox }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/orders/${cartId}/update-international-shipping-info`,
	withCredentials: true,
	data: {
		incoterms,
		netWeight,
		grossWeight,
		dimension, 
		totalBox
	}
});

export const _postCreateInvoice = ({ cartId, offlineReferenceNumber, orderType }) => axios({
	url: `${API_ENDPOINT}/api/admin/order-docs/upload-invoice/${cartId}`,
	withCredentials: true,
	method: 'post',
	data: {
		offlineReferenceNumber,
		orderType
	}
});

export const _postCreateOrderConfirmation = ({ cartId, offlineReferenceNumber, orderType }) => axios({
	url: `${API_ENDPOINT}/api/admin/order-docs/upload-order-confirmation/${cartId}`,
	withCredentials: true,
	method: 'post',
	data: {
		offlineReferenceNumber,
		orderType
	}
});

export const _postQbCreateInvoice = ({ cartId, offlineReferenceNumber, orderType }) => axios({
	url: `${API_ENDPOINT}/api/admin/quickbooks/${cartId}/create-invoice`,
	withCredentials: true,
	method: 'post',
	data: {
		offlineReferenceNumber,
		orderType
	}
});

export const _postDeleteAddress = ({ userId, address }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/users/${userId}/delete-address`,
	data: {
		address
	},
	withCredentials: true
})

export const _deleteAdminPreferenceFilterQuery = ({ userId, queryId }) => axios({
	url: `${API_ENDPOINT}/api/admin/users/admin-preference-filter-query/${userId}/${queryId}`,
	withCredentials: true,
	method: 'delete'
})

export const _postDeleteDataReport = (dataReportId) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/data-report/delete/${dataReportId}`,
	withCredentials: true
})

export const _postDeleteProducts = ({ selectedProducts }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/products/delete`,
	data: {
		selectedProducts
	},
	withCredentials: true
})

export const _postDeleteUser = (userId) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/users/${userId}/delete`,
	withCredentials: true
})

export const _postDuplicateCartToHoldingList = ({ cartId }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/holding-list/duplicate-from-cart/${cartId}`,
	withCredentials: true
});

export const _postMakeHoldingListForAdditionalCharge = ({ cartId }) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/holding-list/additional-charge/${cartId}`
});

export const _postManualDeliveryCharge = (deliveryCharge, cartId) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/quotation/${cartId}/custom-delivery`,
	data: {
		deliveryCharge: deliveryCharge
	}
});

export const _postCustomDeliveryFee = (deliveryCharge, cartId) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/quotation/${cartId}/custom-delivery`,
	data: {
		deliveryCharge: deliveryCharge
	}
});

export const _postCustomDeliveryNote = (deliveryNote, cartId) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/quotation/${cartId}/custom-delivery-note`,
	data: {
		deliveryNote: deliveryNote
	}
});

export const _putCustomPlatformFee = (customPlatformFeeActive, customPlatformFee, cartId) => axios({
	method: "put",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/quotation/${cartId}/custom-platform-fee`,
	data: {
		customPlatformFeeActive, 
		customPlatformFee
	}
});

export const _postSendManualInvoice = ({cartId}) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/orders-v3/send-manual-invoice`,
	data: {
		cartId
	}
});

export const _postNewDeliveryVendor = (name) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/delivery-vendors`,
	data: {
		name
	}
})

export const _postNewBugReport = ({ reportedBy, userId, details, cartId }) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/users/${userId}/bug-report`,
	data: {
		reportedBy,
		cartId,
		details
	}
})

export const _postNewHoldingList = ({ holdingListName, notes = "" }) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/holding-list`,
	data: {
		newHL: {
			name: holdingListName,
			notes
		}
	}
})


export const _postNewDelivery = ({
	cartId,
	products,
	recipient,
	sender,
	cost,
	deliveryMode,
	dateScheduled,
	shipsToCustomer,
	deliveryOption
}) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/orders/${cartId}/new-delivery`,
	data: {
		products,
		addresses: {
			recipient,
			sender,
		},
		cost,
		deliveryMode,
		dateScheduled,
		shipsToCustomer,
		deliveryOption
	}
})

export const _testDeliveries = () => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/delivery/test-delivery`,
	data: {}
})

export const _mergeLocations = ({possibleMerges , dateToChange , deliveryModeToChange, userName,userEmail,userId,}) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/delivery/merge-locations`,
	data: {
		possibleMerges,
		dateToChange,
		deliveryModeToChange,
		userName,
		userEmail,
		userId,
	}
})

export const _postCompanyNameArrayForRecommendedPickups = (companyNameArray, idArray) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/delivery/routes/rec-all-pickups`,
	data: {
		companyNameArray: companyNameArray,
		idArray: idArray
	}
})

export const _postNewReason = ({ reason }) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/orders/additional-charge/reason`,
	data: {
		reason
	}
})

export const _postQbCode = (qbCode) => axios({

	url: `${API_ENDPOINT}/api/admin/quickbooks/get-token`,
	withCredentials: true,
	method: 'post',
	data: {
		qbCode
	}

});

export const _postCheckAndSetBuyerId = ({ cartId }) => axios({
	url: `${API_ENDPOINT}/api/admin/quickbooks/check-and-set-buyer-id`,
	withCredentials: true,
	method: 'post',
	data: {
		cartId
	}
})

export const _postQbSetBuyerId = ({ quickbooksId, quickbooksDisplayName, cartId }) => axios({
	url: `${API_ENDPOINT}/api/admin/quickbooks/set-buyer-id`,
	withCredentials: true,
	method: 'post',
	data: {
		quickbooksId,
		quickbooksDisplayName,
		cartId
	}
})

export const _postQbSetSellerId = ({ quickbooksId, quickbooksDisplayName, supplierId }) => axios({
	url: `${API_ENDPOINT}/api/admin/quickbooks/set-seller-id`,
	withCredentials: true,
	method: 'post',
	data: {
		quickbooksId,
		quickbooksDisplayName,
		supplierId
	}
})


export const _postQbCreateCustomer = (cartId, qbName) => axios({
	url: `${API_ENDPOINT}/api/admin/quickbooks/create-customer`,
	withCredentials: true,
	method: 'post',
	data: {
		cartId,
		qbName
	}
})


export const _postQbCreateSupplier = (supplierId, qbName) => axios({
	url: `${API_ENDPOINT}/api/admin/quickbooks/create-supplier`,
	withCredentials: true,
	method: 'post',
	data: {
		supplierId,
		qbName
	}
})

export const _postQbFindCustomers = (pageNumber, searchTerm) => axios({
	url: `${API_ENDPOINT}/api/admin/quickbooks/find-customers`,
	withCredentials: true,
	method: 'post',
	data: {
		pageNumber,
		searchTerm
	}
})

export const _postQbFindSuppliers = (pageNumber, searchTerm) => axios({
	url: `${API_ENDPOINT}/api/admin/quickbooks/find-suppliers`,
	withCredentials: true,
	method: 'post',
	data: {
		pageNumber,
		searchTerm
	}
})

export const _getReadTagsFromRfidServer = ( scanTime = 10, antennaPower = 0 ) => axios({
	method:"get",
	url: `${RFID_SERVER_ENDPOINT}/tags`,
	params: {
		scanTime,
		antennaPower
	}
})

export const _getRefunds = ({ searchParam, page, pageSize }) => axios({
	url: `${API_ENDPOINT}/api/admin/refunds`,
	withCredentials: true,
	method: 'get',
	params: {
		searchParam,
		page,
		pageSize
	}
})

export const _getQbInitialiseSelections = () => axios({
	url: `${API_ENDPOINT}/api/admin/quickbooks/initialise-selections`,
	withCredentials: true,
	method: 'get',
})

export const _getNewDeliveryOrder = ({ cartId, doId }) => axios({
	method: "get",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/orders/do-new/${cartId}/${doId}`,
})

export const _getDeliveryVendors = () => axios({
	method: 'get',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/delivery-vendors`
})

export const _postDefaultDeliveryVendorId = (userId, defaultDeliveryVendorId) => axios({
	url: `${API_ENDPOINT}/api/admin/users/${userId}/set-preference`,
	withCredentials: true,
	method: 'post',
	data: {
		type: "defaultDeliveryVendorId",
		value: defaultDeliveryVendorId
	}
})

export const _postQbFindAccounts = () => axios({

	url: `${API_ENDPOINT}/api/admin/quickbooks/find-accounts`,
	withCredentials: true,
	method: 'post',
	data: {

	}

});

export const _postResetUniqId = (supplierId) => axios({

	url: `${API_ENDPOINT}/api/admin/supplier/${supplierId}/reset-uniq-id`,
	withCredentials: true,
	method: 'post'

});


export const _postSaveDataReport = (dataReport) => axios({
	url: `${API_ENDPOINT}/api/admin/data-report/${dataReport._id ? dataReport._id : ""}`,
	withCredentials: true,
	method: 'post',
	data: {
		dataReport
	}
})

export const _postShareDataReport = ({email, dataReportId}) => axios({
	url: `${API_ENDPOINT}/api/admin/data-report/share/${dataReportId}`,
	withCredentials: true,
	method: 'post',
	data: {
		email
	}
})

export const _postRemoveShareDataReport = ({email, dataReportId}) => axios({
	url: `${API_ENDPOINT}/api/admin/data-report/share/${dataReportId}/remove`,
	withCredentials: true,
	method: 'post',
	data: {
		email
	}
})

export const _postUpdateDoc = ({title, text, excerpt, docId}) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/update/${docId}`,
	withCredentials: true,
	method: 'post',
	data: {
		title,
		text,
		excerpt
	}
})

export const _postSaveStockUpdateConfig = ({
	supplierId,
	stockCountApprovedEmail,
	stockCountExcelRowStart,
	stockCountExcelQuantityColumn,
	stockCountExcelSupplierSkuColumn
}) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/supplier/stock-config/${supplierId}`,
	data: {
		stockCountApprovedEmail,
		stockCountExcelRowStart,
		stockCountExcelQuantityColumn,
		stockCountExcelSupplierSkuColumn	
	}
})

export const _postEnterprisePathDoc = ({ docId, path }) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/enterprise-path/${docId}`,
	withCredentials: true,
	method: 'post',
	data: {
		path
	}
})

export const _postEnterpriseOciPunchoutCredentials = ({

	ociPunchoutUsername,
	ociPunchoutPassword,
	ociPunchoutProductIdField,
	email,

	enterpriseId, 
	departmentCode,
	isoCountryCode

}) => axios({
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/enterprise/oci-punchout-credential`,
	method: "post",
	data: {
		ociPunchoutUsername,
		ociPunchoutPassword,
		ociPunchoutProductIdField,
		email,

		enterpriseId, 
		departmentCode,
		isoCountryCode
	}
});


export const _postToggleDocCategoryActive = (docCategoryId) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/category/toggle-active/${docCategoryId}`,
	withCredentials: true,
	method: 'post'
})

export const _postToggleDocSubCategoryActive = (docSubCategoryId) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/category/toggle-sub-active/${docSubCategoryId}`,
	withCredentials: true,
	method: 'post'
})

export const _postToggleDocActive = ({ docId, isActive }) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/toggle-active/${docId}`,
	withCredentials: true,
	method: 'post',
	data: {
		isActive
	}
})

export const _postToggleDocEnterprise = ({ docId, isEnterprise }) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/toggle-enterprise/${docId}`,
	withCredentials: true,
	method: 'post',
	data: {
		isEnterprise
	}
})

export const _postSaveDocPage = ({ docId, content, title }) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/page/${docId}`,
	withCredentials: true,
	method: 'post',
	data: {
		content,
		title
	}
})

export const _postEditDocPage = ({ docPageId, content, title }) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/page/edit/${docPageId}`,
	withCredentials: true,
	method: 'post',
	data: {
		content,
		title
	}
})

export const _postReorderDocPages = ({ docId, startIndex, endIndex }) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/reorder/${docId}`,
	withCredentials: true,
	method: 'post',
	data: {
		startIndex,
		endIndex
	}
})

export const _postRemoveDocPage = (docPageId) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/page/inactive/${docPageId}`,
	withCredentials: true,
	method: 'post'
})

export const _postEditDocTitle = ({ docId, title }) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/edit/${docId}`,
	withCredentials: true,
	method: 'post',
	data: {
		title
	}
})

export const _postToggleDocPageActive = ({ docPageId, isActive }) => axios({
	url: `${API_ENDPOINT}/api/admin/docs/page/toggle-active/${docPageId}`,
	withCredentials: true,
	method: 'post',
	data: {
		isActive
	}
})

export const _postSaveWhiteLabelSettings = ({ userId, whiteLabelSettings }) => axios({
	url: `${API_ENDPOINT}/api/admin/supplier/${userId}/white-label-settings`,
	withCredentials: true,
	method: 'post',
	data: {
		whiteLabelSettings
	}
})

export const _postSearchBugs = ({ page, limit, searchTerm, statusFilter = [], severityFilter = [], originFilter = [], relationshipFilter = [], agentFilter = [], typeFilter = [] }) => axios({
	withCredentials: true,
	url: `${API_ENDPOINT}/api/bugs/search`,
	method: 'post',
	data: {
		page,
		limit,
		searchTerm,
		statusFilter,
		severityFilter,
		originFilter,
		relationshipFilter,
		agentFilter,
		typeFilter
	}
})

export const _postSearchAllSuppliers = ({ page, searchTerm }) => axios({
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/users/get-all-suppliers/${page}`,
	method: 'post',
	data: {
		searchTerm
	}
})

export const _postSelectCustomProduct = ({
	holdingListId,
	productIndex,
	customProductId
}) => axios({
	url: `${API_ENDPOINT}/api/admin/holding-list/select-custom-product`,
	withCredentials: true,
	method: 'post',
	data: {
		holdingListId,
		productIndex,
		customProductId
	}
});

export const _postSaveSubCategoryImage = ({ subKebabCase, categoryId, image }) => axios({
	url: `${API_ENDPOINT}/api/category/sub-image/${categoryId}`,
	withCredentials: true,
	method: 'post',
	data: {
		subKebabCase,
		image
	}
})

export const _postSetOfflineReferenceNumber = ({ cartId, offlineReferenceNumber }) => axios({
	url: `${API_ENDPOINT}/api/admin/orders/${cartId}/set-order-offline-reference`,
	withCredentials: true,
	method: 'post',
	data: {
		offlineReferenceNumber
	}
})

export const _postSetOrderFulfilled = ({ cartId }) => axios({
	url: `${API_ENDPOINT}/api/admin/orders/${cartId}/set-order-progress`,
	withCredentials: true,
	method: 'post',
	data: {
		inProgress: false
	}
})

export const _postSetOrderInProgress = ({ cartId }) => axios({
	url: `${API_ENDPOINT}/api/admin/orders/${cartId}/set-order-progress`,
	withCredentials: true,
	method: 'post',
	data: {
		inProgress: true
	}
})

export const _postSetProductOrderStatusToAwaitPayment = ( orderStatusId, productOrderStatusIds ) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/order-status/${orderStatusId}/set-await-payment`,
	withCredentials: true,
	data: {
		productOrderStatusIds
	}
});

export const _postSetRestockDate = ({
	cartId,
	month
}) => axios({
	url: `${API_ENDPOINT}/api/admin/orders/${cartId}/restock-date`,
	withCredentials: true,
	method: 'post',
	data: {
		month
	}
})

export const _postSetRetagSuccess = ( tagIds ) => axios({
	url: `${API_ENDPOINT}/api/admin/products/retag-rfid-success`,
	withCredentials: true,
	method: "post",
	data: {
		tagIds
	}
})

export const _postSendCheckStockEmail = ({ cartId, products, supplierId, admin, firstName, toEmail }) => axios({
	url: `${API_ENDPOINT}/api/admin/orders/check-stock-email/${cartId}`,
	withCredentials: true,
	method: 'post',
	data: {
		products,
		supplierId,
		admin,
		firstName,
		toEmail
	}
});

export const _postSendQuotation = (cartId) => axios({
	url: `${API_ENDPOINT}/api/admin/quotation/${cartId}/send`,
	withCredentials: true,
	method: 'post'
});

export const _postSetAdminPreference = ({ userId, type, value }) => axios({
	url: `${API_ENDPOINT}/api/admin/users/${userId}/set-preference`,
	withCredentials: true,
	method: 'post',
	data: {
		type,
		value
	}

})

export const _postSetAdminPermission = ({ userId, ezPermissionId }) => axios({
	url: `${API_ENDPOINT}/api/admin/permissions/set-user`,
	withCredentials: true,
	method: 'post',
	data: {
		userId,
		ezPermissionId
	}

})


export const _postSetCustomBulkDiscount = ({
	discount,
	productIndex,
	holdingListId
}) => axios({
	url: `${API_ENDPOINT}/api/admin/holding-list/${holdingListId}/product-bulk-discount/${productIndex}/${discount}`,
	withCredentials: true,
	method: "post"
})

export const _postSetQuotationBilling = ({
	quotationId,
	userId,
	locationId
}) => axios({
	url: `${API_ENDPOINT}/api/admin/quotation/${quotationId}/billing/${userId}/${locationId}`,
	withCredentials: true,
	method: "post"
});

export const _postSetQuotationCurrency = ({
	quotationId,
	currency
}) => axios({
	url: `${API_ENDPOINT}/api/admin/quotation/${quotationId}/currency/${currency}`,
	withCredentials: true,
	method: "post"
});

export const _postSetQuotationShipping = ({
	quotationId,
	userId,
	locationId
}) => axios({
	url: `${API_ENDPOINT}/api/admin/quotation/${quotationId}/shipping/${userId}/${locationId}`,
	withCredentials: true,
	method: "post"
})

export const _postSetQuotationHoldingList = ({
	quotationId,
	holdingListId
}) => axios({
	url: `${API_ENDPOINT}/api/admin/quotation/${quotationId}/holding-list/${holdingListId}`,
	withCredentials: true,
	method: "post"
})

export const _postSetQuotationPaymentTermDays = ({
	quotationId,
	paymentTermDays
}) => axios({
	url: `${API_ENDPOINT}/api/admin/quotation/${quotationId}/payment-term-days`,
	withCredentials: true,
	method: "post",
	data: {
		paymentTermDays
	}
});
export const _postLocationToOptimize = ({locationIds, driverId, userId, routeDate,userName,userEmail}) => axios({
	url: `${API_ENDPOINT}/api/admin/delivery/optimize-free`,
	withCredentials: true,
	method: "post",
	data: {
		locationIds,
		driverId,
		routeDate,
		userName,
		userEmail,
		userId,
	}
})
export const _splitLocation = ({productOrderStatusIdArray,deliveryLocationId,dateToChange,deliveryModeToChange}) => axios({
	url: `${API_ENDPOINT}/api/admin/delivery/split-products`,
	withCredentials: true,
	method: "post",
	data: {
		productOrderStatusIdArray,
		deliveryLocationId,
		dateToChange,
		deliveryModeToChange
	}
})
export const _optimizeVrp = (date) => axios({
	url: `${API_ENDPOINT}/api/admin/delivery/routes/optimize/vrp`,
	withCredentials: true,
	method: "post",
	data: {
		date: date
	}
})

export const _postLocationIdToDelete = ({ dateScheduled, id }) => axios({
	url: `${API_ENDPOINT}/api/admin/delivery/routes/delete-location`,
	withCredentials: true,
	method: "post",
	data: {
		dateScheduled,
		id
	}
});

export const _postRetrieveSupplierDetails = ({
	suppliers
}) => axios({
	url: `${API_ENDPOINT}/api/admin/supplier/retrieve-details`,
	withCredentials: true,
	method: "post",
	data: {
		suppliers
	}
});

export const _postRetrieveTopBrandsFromCategory = ({categoryKebabName, options = { sub: true }}) => axios({
	url: `${URL_ENDPOINT}/api/category/top-brands-from-category`,
	withCredentials: true,
	method: 'post',
	data: {
		options,
		categoryKebabName
	}
})

export const _postSplitDelivery = ({ cartId, deliveryId, productsToEdit, newDeliveryDetails }) => axios({
	withCredentials: true,
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/orders/${cartId}/${deliveryId}/split-delivery`,
	data: {
		productsToEdit,
		newDeliveryDetails
	}
})


export const _postRegisterGhostUser = (email) => axios({
	withCredentials: true,
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/users/ghost?email=${email}`
})

export const _postToggleEnterprisePermission = ({ userId, key }) => axios({
	withCredentials: true,
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/enterprise/toggle-permission`,
	data: {
		userId,
		key
	}
})

export const _postToggleQuotationFreeDelivery = ({ quotationId, freeDelivery }) => axios({
	withCredentials: true,
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/quotation/${quotationId}/free-delivery`,
	data: {
		freeDelivery,
		//deliveryCharge //added by bryce
	}
})

export const _postToggleQuotationGstWaived = ({ quotationId, gstWaived }) => axios({
	withCredentials: true,
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/quotation/${quotationId}/gst-waived`,
	data: {
		gstWaived
	}
})

export const _deleteEnterprise = (enterpriseId) => axios({
	url: `${API_ENDPOINT}/api/admin/enterprise/${enterpriseId}`,
	withCredentials: true,
	method: 'delete'
});

export const _deleteDeliveryVendor = (deliveryVendor) => axios({
	url: `${API_ENDPOINT}/api/admin/delivery-vendors/${deliveryVendor._id}`,
	withCredentials: true,
	method: 'delete'
})

export const _deleteQuotation = (_id) => axios({
	url: `${API_ENDPOINT}/api/admin/quotation/${_id}`,
	withCredentials: true,
	method: 'delete'
})

export const _deleteHoldingList = (holdingListId) => axios({
	url: `${API_ENDPOINT}/api/admin/holding-list/${holdingListId}`,
	withCredentials: true,
	method: 'delete',
})

export const _deleteHoldingListProduct = ({ holdingListId, productIndex }) => axios({
	url: `${API_ENDPOINT}/api/admin/holding-list/${holdingListId}/product/${productIndex}`,
	withCredentials: true,
	method: 'delete'
})

export const _deleteHoldingListClearProducts = (holdingListId) => axios({
	url: `${API_ENDPOINT}/api/admin/holding-list/${holdingListId}/clear`,
	withCredentials: true,
	method: 'delete'
})



/**
 * _postAddEnterprise - adds an enterprise and assigns to user if provided with userId
 */
export const _postAddEnterprise = (data) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/enterprise`,
	data,
	withCredentials: true
});

export const _postAddCreditNote = ({ cartId, reason, amount, discount }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/orders/credit-note`,
	data: {
		cartId,
		reason,
		amount,
		discount
	},
	withCredentials: true
})

export const _postAdditionalCharge = ({ cartId, reasonId, amount, comments }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/orders/additional-charge`,
	data: {
		cartId,
		reasonId,
		amount,
		comments
	},
	withCredentials: true
});

export const _postCartLastDelivered = ({ cartId, date, enterpriseId }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/cart/lastdelivered`,
	data: {
		cartId,
		date,
		enterpriseId
	},
	withCredentials: true
})

export const _postUpdateCustomProductTitle = ({ productIndex, productTitle, holdingListId }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/holding-list/custom-product/update-product-title`,
	data: {
		productTitle,
		productIndex,
		holdingListId
	},
	withCredentials: true
});

export const _postUpdateCustomProductPrice = ({ holdingListId, productPrice, productIndex }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/holding-list/update-custom-product-price`,
	data: {
		holdingListId,
		productPrice,
		productIndex
	},
	withCredentials: true

});

export const _postUpdateEnterpriseCreditLimit = ({ enterpriseId, creditLimit }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/enterprise/update-credit-limit/${enterpriseId}`,
	data: {
		creditLimit
	},
	withCredentials: true
})

export const _postUpdateEnterprisePunchoutSettings = ({
	punchoutModule,
	punchoutSendPoomEncodeType,
	punchoutIsPaymentProxyDisabled,
	punchoutBuyerId,
	punchoutSellerId,
	punchoutNetworkId,
	punchoutSharedSecret,
	punchoutApplication,
	punchoutLeadTime,
	punchoutTaxConfiguration,
	punchoutUomMapping,
	enterpriseId
}) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/enterprise/punchout`,
	data: {
		punchoutModule,
		punchoutSendPoomEncodeType,
		punchoutIsPaymentProxyDisabled,
		punchoutBuyerId,
		punchoutSellerId,
		punchoutNetworkId,
		punchoutSharedSecret,
		punchoutApplication,
		punchoutLeadTime,
		punchoutTaxConfiguration,
		// undefined is dropped by JSON serialisation, so the server sees the key as absent
		punchoutUomMapping,
		enterpriseId,
	},
	withCredentials: true
});

export const _postUpdateEnterpriseRestrictedBrandsSettings = ({
	enterpriseId,
	restrictedBrands,
	restrictedBrandsModule
}) => axios({
	withCredentials: true,
	method: "post",
	url: `${API_ENDPOINT}/api/admin/enterprise/restricted-brands/${enterpriseId}`,
	data: {
		restrictedBrands,
		restrictedBrandsModule
	}
});

export const _postUpdateEnterpriseRestrictedCategorySettings = ({
	enterpriseId,
	restrictedCategories,
	restrictedCategoriesModule
}) => axios({
	withCredentials: true,
	method: "post",
	url: `${API_ENDPOINT}/api/admin/enterprise/restricted-categories/${enterpriseId}`,
	data: {
		restrictedCategories,
		restrictedCategoriesModule
	}
});

export const _postUpdateEnterpriseSettings = ({
	companyName,
	movFreeDelivery,
	logoUrl,
	domainName,
	enterpriseId,
	dayOfDelivery,
	deliveryBuffer,
	shortName,
	creditTermDays,
	creditLimit,
	domainNames,
	paymentMethodsAvailable,
	remarks,
	financeRemarks,
	departmentCodes,
	subDepartmentCodes,
	isTest,
	checkoutThreshold
}) => axios({
	withCredentials: true,
	method: "post",
	url: `${API_ENDPOINT}/api/admin/enterprise/settings/${enterpriseId}`,
	data: {
		companyName,
		movFreeDelivery,
		logoUrl,
		domainName,
		dayOfDelivery,
		deliveryBuffer,
		shortName,
		creditTermDays,
		creditLimit,
		domainNames,
		paymentMethodsAvailable,
		remarks,
		financeRemarks,
		departmentCodes,
		subDepartmentCodes,
		isTest,
		checkoutThreshold
	}
})

export const _postUpdateEnterpriseCoretaxCustomFields = ({ enterpriseId, coretaxCustomFields }) => axios({
	withCredentials: true,
	method: "post",
	url: `${API_ENDPOINT}/api/admin/enterprise/custom-fields/coretax/${enterpriseId}`,
	data: {
		coretaxCustomFields
	}
})

export const _postUpdateEnterpriseLhdnCustomFields = ({ enterpriseId, lhdnCustomFields }) => axios({
	withCredentials: true,
	method: "post",
	url: `${API_ENDPOINT}/api/admin/enterprise/custom-fields/lhdn/${enterpriseId}`,
	data: {
		lhdnCustomFields
	}
})

export const _postUpdateLeadTime = ({ cartId, leadTime, productCheckoutId }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/orders/${cartId}/update-lead-time`,
	data: {
		cartId,
		leadTime,
		productCheckoutId
	},
	withCredentials: true
})

export const _postUpdateOrderAgent = (cartId, agentId) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/orders/${cartId}/${agentId}/update-agent`,
	withCredentials: true
})

/**
 * @param {Object[]} reduceProductOrderStatusQty
 * @param {number} reduceProductOrderStatusQty[].qty
 * @param {string} reduceProductOrderStatusQty[].productOrderStatusId
 */
export const _postUpdateProductOrderStatusQty = ( orderStatusId, reduceProductOrderStatusQty ) => axios({
	withCredentials: true,
	method: "post",
	url: `${API_ENDPOINT}/api/admin/order-status/${orderStatusId}/reduce-product-order-status-qty`,
	data: reduceProductOrderStatusQty
})

export const _editShippingAddress = ({cartId, address}) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/orders/edit-shipping-address`,
	withCredentials: true,
	data: {
		cartId,
		address
	}
})

export const _postWaiveGst = ({ quotationId }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/quotation/${quotationId}/waive-gst`,
	withCredentials: true
})

export const _postWriteTagsToRfidServer = ( writeTagsInstructions ) => axios({
	method: "post",
	url: `${RFID_SERVER_ENDPOINT}/write-tags`,
	data: writeTagsInstructions
})

export const _postAssignEnterpriseToUser = ({ enterpriseId, userId }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/enterprise/assign-to-user`,
	data: {
		enterpriseId,
		userId
	},
	withCredentials: true
})

export const _postBanner = (banner) => axios({
	data: {
		banner
	},
	method: 'post',
	url: `${API_ENDPOINT}/api/banners/new`,
	withCredentials: true
})

export const _postChangePermission = ({ unit, _id }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/users/permissions/${unit}/${_id}`,
	withCredentials: true
})

export const _postChangeSupplierForOrder = ({ cartId, supplierId, productIds }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/orders/${cartId}/change-supplier`,
	withCredentials: true,
	data: {
		supplierId,
		productIds
	}
})

export const _postChangeSupplierForProduct = ({ productId, supplierId, enquiryId }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/enquiry/${enquiryId}/${productId}/change-supplier/${supplierId}`,
	withCredentials: true,
})

export const _postDeleteOneBanner = (bannerId) => axios({
	method: 'delete',
	url: `${API_ENDPOINT}/api/banners/delete/${bannerId}`,
	withCredentials: true
})

export const _postDeleteMainCategory = ({ mainCategory }) => axios({
	method: "delete",
	url: `${API_ENDPOINT}/api/admin/category/${mainCategory.titleUrl}`,
	withCredentials: true
})

export const _postDeleteSubCategory = ({ mainCategory, subCategory }) => axios({
	method: "delete",
	url: `${API_ENDPOINT}/api/admin/category/${mainCategory.titleUrl}/${subCategory.titleUrl}`,
	withCredentials: true
})

export const _putUpdateSubCategoryGoogleTaxonomy = async ({subCategory, googleTaxonomy}) => axios({
	method: "put",
	url: `${API_ENDPOINT}/api/admin/category/sub/${subCategory.titleUrl}/google-taxonomy`,
	withCredentials: true,
	data: {
		googleTaxonomy
	}
})

export const _postDeliveryOrderToDrive = ({ doId, orderId, body, uploadedBy }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/order-docs/upload-delivery-order/${orderId}/${doId}/${uploadedBy}`,
	withCredentials: true,
	data: {
		body
	}
})

export const _postDownloadCsvForGoogle = (selectedProducts) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/products/google-csv`,
	withCredentials: true,
	data: {
		selectedProducts
	}
})

export const _postEditDeliveryCost = ({ cartId, deliveryCost, deliveryId }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/orders/${cartId}/${deliveryId}/edit-cost`,
	data: {
		deliveryCost
	},
	withCredentials: true
})

export const _postEditEnterprise = ({ enterpriseId, data }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/enterprise/edit/${enterpriseId}`,
	data,
	withCredentials: true
})

export const _postGdCode = (gdCode) => axios({

	url: `${API_ENDPOINT}/api/admin/order-docs/get-token`,
	withCredentials: true,
	method: 'post',
	data: {
		gdCode
	}

});

export const _postLogoutFromAllDevices = ({ userId }) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/developer/logout-devices/${userId}`,
})

export const _postRemoveUserFromEnterprise = ({ enterpriseId, userId }) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/enterprise/user/remove`,
	data: {
		enterpriseId,
		userId
	}
})

export const _postAddPurchaseOrderRefNumber = ({ cartId, poRefNumber }) => axios({
	url: `${API_ENDPOINT}/api/cart/add-purchase-order/${cartId}/${poRefNumber}`,
	method: 'post',
	withCredentials: true,
	data: {
		cartId,
		poRefNumber
	}
})

export const _postToggleEnterprisePending = ({ cartId }) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/cart/${cartId}/enterprisepending`,
	data: {
		cartId
	}
})

export const _postToggleEnterprisePaid = ({ cartId }) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/cart/${cartId}/enterprisepaid`,
	data: {
		cartId
	}
})

export const _postToggleFinancePermission = ({ enterpriseId, userId }) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/enterprise/${enterpriseId}/toggle/finance/${userId}`,
})

export const _postToggleShopActive = ({ userId }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/supplier/toggle-shop-active/${userId}`,
	withCredentials: true
})

export const _postToggleFlaggedForDelete = ({ userId }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/supplier/toggle-flagged-for-delete/${userId}`,
	withCredentials: true
})

export const _postToggleSuspended = ({ userId, suspended }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/supplier/toggle-suspended/${userId}`,
	withCredentials: true,
	data: {
		suspended: suspended
	}
})

export const _postToggleSuperuserPermission = ({ enterpriseId, userId }) => axios({
	method: 'post',
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/enterprise/${enterpriseId}/toggle/superuser/${userId}`,
})

export const _postUpdatedSupplierDetails = ({ supplierId, movAmount, remarks }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/supplier/adminEditInfo/${supplierId}`,
	data: {
		movAmount,
		remarks
	},
	withCredentials: true
})
export const _generateGantt = (date, focusDate) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/delivery/generate-gantt-chart`,
	data: {
		date: date,
		focusDate: focusDate
	},
	withCredentials: true
})
export const _postUpdateHoldingListQuantity = ({ holdingListId, productIndex, quantity, enterpriseId = null }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/holding-list/product/update-quantity`,
	data: {
		holdingListId,
		productIndex,
		quantity,
		enterpriseId
	},
	withCredentials: true
})

export const _postUpdateHoldingListSerialNumber = ({ holdingListId, holdingListProductsSerialNumber }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/holding-list/product/update-serial-number`,
	data: {
		holdingListId,
		holdingListProductsSerialNumber
	},
	withCredentials: true
})

export const _postUpdateHoldingListPrices = ({enterpriseId, holdingListId}) => axios({
  method: 'post', 
  url: `${API_ENDPOINT}/api/admin/holding-list/update-prices`,
  data: {
    holdingListId,
    enterpriseId
  },
  withCredentials: true
})

export const _downloadOptimalRouteCsv = id => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/delivery/routes/downloadCsv`,
	withCredentials: true,
	data: {
		id: id
	},
	responseType: 'blob',
})

export const _getPurchaseInvoice = (cartId, supplierId) => axios({
	method: "get",
	url: `${API_ENDPOINT}/api/admin/order-docs/get-purchase-invoice/${cartId}/${supplierId}`,
	withCredentials: true
})

export const _getPurchaseInvoiceData = ({cartId, supplierIds}) => axios({
	method: "get",
	url: `${API_ENDPOINT}/api/admin/orders-v3/purchase-invoices-data`,
	withCredentials: true,
	params: {
		cartId,
		supplierIds
	}
})

export const _getPaymentSlip = (cartId, supplierId) => axios({
	method: "get",
	url: `${API_ENDPOINT}/api/admin/order-docs/get-payment-slip/${cartId}/${supplierId}`,
	withCredentials: true
})
export const _getRoutes = ([startDate, endDate]) => axios({
	method: "get",
	url: `${API_ENDPOINT}/api/admin/delivery/routes/delivery-routes`,
	data: {
		start: startDate,
		end: endDate
	},
	withCredentials: true
})

export const _getOptimizedRoute = (routeId) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/delivery/routes/optimized-routes`,
	data: {
		id: routeId
	},
	withCredentials: true
})

export const _getUsersForRoute = () => axios({
	method: "get",
	url: `${API_ENDPOINT}/api/admin/delivery/users`,
	withCredentials: true
})
export const _getSuppliers = ({searchTerm}) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/delivery/suppliers`,
	withCredentials: true,
	data: {
		searchTerm
	}
})

export const _getManySuppliers = (
	{
		pageSize,
		pageNumber,
		searchParams
	}
) => axios({
	method: "GET",
	url: `${API_ENDPOINT}/api/admin/supplier/paginate`,
	withCredentials: true,
	params: {
		pageSize,
		pageNumber,
		searchParams
	}
})

/**
 * @typedef {{
 * 		destinationSupplierId: string,
 * 		createdByUserId?: string,
 * 		createdAt: Date,
 * 		_id: string,
 * 		retryErrorCount?: number,
 * 		markedToDeleteDuplicatedProductsDate?: Date
 * }} T_DuplicateProductJob
 */
/**
 * @typedef {{
 * 		completedLineItemsCount: number,
 * 		totalLineItemsCount: number,
 * 		duplicateProductJob: T_DuplicateProductJob
 * }} T_DuplicateProductJobProgressDTO
 */
/**
 * @param {Object} args
 * @param {number} args.pageNumber
 * @param {number} args.pageSize
 * @returns {Promise<{
 * 		data: {
 * 				data: T_DuplicateProductJobProgressDTO[],
 * 				totalRecordCount: number
 * 		}
 * }>}
 */
export const _getManyDuplicateProductJobProgressDtos = (
	args
) => axios({
	method: "GET",
	url: `${API_ENDPOINT}/api/admin/duplicate-product-jobs/progress`,
	withCredentials: true,
	params: args,
})

export const _getDeliveryColors = () => axios({
	method: "get",
	url: `${API_ENDPOINT}/api/admin/delivery/get-delivery-colors`,
	withCredentials: true,
	data: {}
})
export const _addDeliveryColors = ({color , description,userName,userEmail,userId}) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/delivery/add-delivery-colors`,
	withCredentials: true,
	data: {
		color,
		description,
		userName,
		userEmail,
		userId,
	}
})
export const _deleteDeliveryColor = (color) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/delivery/delete-delivery-colors`,
	withCredentials: true,
	data: {
		color: color
	}
})
export const _tagDeliveryColors = ({idArray, color, action, userName,userEmail,userId,colorDesc}) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/delivery/tag-delivery-colors`,
	withCredentials: true,
	data: {
		idArray,
		color,
		action,
		userName,
		userEmail,
		userId,
		colorDesc
	}
})
export const _emailAllLocationById = ({ locationsToEmail, routeId, userName,userEmail,userId }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/delivery/send-email`,
	data: {
		locationsToEmail,
		routeId,
		userName,
		userEmail,
		userId
	},
	withCredentials: true
})
export const _postCompleteLocationActionById = (locationId , userName, userEmail,userId) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/delivery/optimized-route/complete`,
	data: {
		locationId: locationId,
		userName,
        userEmail,
        userId,
	},
	withCredentials: true
})

export const _deleteLocationById = (deliveryId) => axios({
	method: 'DELETE',
	url: `${API_ENDPOINT}/api/admin/delivery/${deliveryId}`,
	withCredentials: true
})

export const _postSearchCustomProducts = (searchParam) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/custom-product/search`,
	data: {
		searchParam
	},
	withCredentials: true
})

// export const _postSearchDeliveries = (searchParam, deliveryMode) => axios({
// 	method: 'post',
// 	url: `${API_ENDPOINT}/api/admin/delivery/routes/search`,
// 	data: {
// 		searchParam: searchParam,
// 		deliveryMode: deliveryMode
// 	},
// 	withCredentials: true
// })

export const _postSearchProducts = (query, limit) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/products/search`,
	data: {
		query,
		limit
	},
	withCredentials: true
})

export const _getDuplicateProductsExcel = () => axios({
	method: "GET",
	url: `${API_ENDPOINT}/api/admin/duplicate-product-jobs-excel`,
	withCredentials: true,
	responseType: "blob"
})


/**
 * @typedef {{
 * 		success: boolean,
 * 		errorType?: "INVALID_FILE_FORMAT" | "DUPLICATE_OR_MISSING_INPUT" | "INVALID_PRODUCT_IDS",
 * 		errorXlsxUrl?: string,
 * }} T_DuplicateProductJobValidationResponse
 */

/**
 * @return {Promise<{data: T_DuplicateProductJobValidationResponse}>}
 */
export const _postDuplicateProductsExcel = (
	{
		file,
		supplierId
	}
) => {

	const headers = { "content-type": "multipart/form-data" }
	const formData = new FormData();
	formData.append("duplicate-products-excel", file)

	return axios({
		method: "POST",
		url: `${API_ENDPOINT}/api/admin/duplicate-product-jobs-excel`,
		headers,
		withCredentials: true,
		data: formData,
		params: {
			supplierId
		}
	})
}

/**
 * Deleted by user id will be saved on eezee server.
 */
/** @param {{
 * 		duplicatedProductJobId: string,
 * }} args */
export const _postDuplicateProductJobDeleteDuplicatedProducts = (args) => axios({
	method: "POST",
	url: `${API_ENDPOINT}/api/admin/duplicate-product-jobs/delete-duplicated-products/${args.duplicatedProductJobId}`,
	withCredentials: true
})

export const _postSupplierAlternateAddress = ({ address, supplierId }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/supplier/create-alternate-address/${supplierId}`,
	data: {
		address
	},
	withCredentials: true
})

export const _postSupplierAlternateDetails = ({ details, supplierId }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/supplier/create-alternate-details/${supplierId}`,
	data: {
		details
	},
	withCredentials: true
})

export const _postEditSupplierDetails = ({ details, supplierId }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/supplier/edit-details/${supplierId}`,
	data: {
		details
	},
	withCredentials: true
})

export const _postSupplierAlternateEmail = ({ email, supplierId }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/supplier/create-alternate-email/${supplierId}`,
	data: {
		email
	},
	withCredentials: true
})

export const _postTransferProducts = ({ selectedProducts, to }) => axios({
	method: "post",
	url: `${API_ENDPOINT}/api/admin/products/transfer`,
	data: {
		selectedProducts,
		to
	},
	withCredentials: true
})

export const _postUpdatedBanner = (banner, bannerId) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/banners/edit/${bannerId}`,
	data: {
		banner
	},
	withCredentials: true
})

export const _postUpdateBannersAfterArranging = (updatedBanners) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/banners/update-banners`,
	data: {
		updatedBanners
	},
	withCredentials: true
})

export const _postAddLeafPage = (leafName, description, imageURL, position, mobileName, industry) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/leaf-page/add/leaf-page`,
	data: {
		leafName,
		description,
		position,
		imageURL,
		mobileName,
		industry
	},
	withCredentials: true,
})

export const _postDeleteLeafPage = (leafId) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/leaf-page/delete/${leafId}`,
	withCredentials: true,
})

export const _postReorderLeafPage = (newList) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/leaf-page/reorder/leaf-page`,
	data: {
		newList
	},
	withCredentials: true,
})

export const _postUpdateLeafPage = (newLeafPage) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/leaf-page/update/leaf-page`,
	data: {
		newLeafPage
	},
	withCredentials: true
})

export const _postUpdateLeafDetails = (_id, leafName, description, imageURL, link) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/leaf-page/update/leaf-page/details`,
	data: {
		leafObj: { _id, leafName, description, imageURL, link },
	},
	withCredentials: true
})


export const _postAddNewIotDevice = ({ deviceName, deviceType, enterpriseId }) => axios({
	method: "post",
	withCredentials: true,
	url: `${API_ENDPOINT}/api/admin/iot-devices`,
	data: {
		deviceName,
		deviceType,
		enterpriseId
	}
})










export const _postSetProductOrderStatusPaid = (productOrderStatusIds) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/payment/paid`,
	data: {
		productOrderStatusIds
	},
	withCredentials: true
})


export const _postSearchCreditApplication = ({searchTerm, page, limit, approvalStatusFilter}) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/enterprise/search-credit-application`,
	withCredentials: true,
	data: {
		searchTerm,
		page,
		limit,
		approvalStatusFilter
	}
})

export const _postApproveCreditApplication = ({enterpriseId, creditLimit, creditTermDays}) => axios({
	method:'post',
	url:`${API_ENDPOINT}/api/admin/enterprise/approve-credit-application`,
	withCredentials: true,
	data: {
		enterpriseId,
		creditLimit,
		creditTermDays,
	}
})

export const _postRejectCreditApplication = ({enterpriseId, approver}) => axios({
	method:'post',
	url:`${API_ENDPOINT}/api/admin/enterprise/reject-credit-application`,
	withCredentials: true,
	data: {
		enterpriseId,
		approver,
	}
})

export const _getBuyers = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/explore/buyers`,
	withCredentials: true,
})

export const _getSellers = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/explore/sellers`,
	withCredentials: true,
})

export const _getPageTypes = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/explore/marketing`,
	withCredentials: true
})

export const _getUserFromBuyer = ({buyerName}) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/explore/users`,
	withCredentials: true,
	params: {
		buyerName
	}
})

export const _getDailyGMV = ({startDate,endDate}) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/explore/overall-data/daily`,
	withCredentials: true,
	params: {
		startDate,
		endDate,
	}
})

export const _getOverallDataByCategory = ({startDate,endDate}) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/explore/overall-data/category`,
	withCredentials: true,
	params: {
		startDate,
		endDate,
	}
})

export const _getOverallDataCustomers = ({startDate,endDate}) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/explore/overall-data/customers`,
	withCredentials: true,
	params: {
		startDate,
		endDate,
	}
})

export const _getCanDevLogin = ( userId ) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/users/admin/can-dev-login/${userId}`,
	withCredentials: true,
})

export const _getSupplierList = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/vm/supplier/all`,
	withCredentials: true,
})

export const _getSearchEnterprises = (searchParam) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/vm/enterprise/search`,
	withCredentials: true,
	params: {
		searchParam
	}
})

export const _getIotDevices = ( filter = { enterpriseId: "", deviceType: "" }) => axios({
	method: "get",
	url: `${API_ENDPOINT}/api/admin/iot-devices`,
	withCredentials: true,
	params: {
		enterpriseId: filter.enterpriseId, 
		deviceType: filter.deviceType
	}
})

export const _getTrackEvent = ({ 
	cartId = "",
	ev, 
	productIds = "", 
	medium = "", 
	pageType = "",
	BRAND = "",
	SUB_CATEGORY = "",
	MAIN_CATEGORY = "",
	SUPPLIER_ID = "",
	SEARCH_QUERY,
	SEARCH_SIZE_COUNT
}) => axios({
	url: `${API_ENDPOINT}/api/events/tr`,
	params: {
		ev,
		productIds,
		medium,
		pageType,
		cartId,
		BRAND,
		SUB_CATEGORY,
		MAIN_CATEGORY,
		SUPPLIER_ID,
		SEARCH_QUERY,
		SEARCH_SIZE_COUNT
	},
	withCredentials: true,
	method: "get"
})

export const _getTableNames = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/data/table-names`,
	withCredentials: true,
})

export const _getFieldNames = (selectedTable) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/data/field-names`,
	withCredentials: true,
	params: {
		selectedTable
	}
})

export const _getMassUploadPending = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/products/mass-upload-pending`,
	withCredentials: true
})

export const _getEnterpriseCustomers = (searchParam = "", page = 1, limit = 10, allEnterpriseFlag) => axios({
    method: 'get',
    withCredentials: true,
    url: `${API_ENDPOINT}/api/admin/customer?searchParam=${searchParam}&page=${page}&limit=${limit}&allEnterpriseFlag=${allEnterpriseFlag}`
}) 

export const _getVipPrices = (searchParam, page, limit, customerId) => axios({
    method: 'get',
    url: `${API_ENDPOINT}/api/admin/vip-price/${customerId}?searchParam=${searchParam}&page=${page}&limit=${limit}`,
    withCredentials: true  
})

export const _getVmSuppliers = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/vm/supplier`,
	withCredentials: true
})

export const _getVmList = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/vm/vms`,
	withCredentials: true
})

export const _getVmProducts = ({dataOrigin}) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/vm/products`,
	withCredentials: true,
	params: {
		dataOrigin
	}
})

export const _getVmSales = ({dataOrigin, startDate, endDate}) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/vm/sales`,
	withCredentials: true,
	params: {
		dataOrigin,
		startDate,
		endDate
	}
})

export const _getVms = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/vm`,
	withCredentials: true,
})


export const _postDataQuery = ({query, selectedFields, selectedTable}) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/data`,
	withCredentials: true,
	data: {
		query,
		selectedFields, 
		selectedTable
	}
})

export const _postDownloadDataQuery = ({query, selectedFields, selectedTable}) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/data/download`,
	withCredentials: true,
	data: {
		query,
		selectedFields, 
		selectedTable
	}
})

export const _getFinanceNotifications = ({page, limit, statusFilter, typeFilter, createdByFilter, refNumber_search, offlineReferenceNumber_search}) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/finance/notifications-paginate`,
	withCredentials: true,
	data: {
		page,
		limit,
		statusFilter, 
		typeFilter, 
		createdByFilter,
		refNumber_search,
		offlineReferenceNumber_search
	}
})

export const _getFinanceNotificationForOrder = ({cartId}) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/finance/notification/order`,
	withCredentials: true,
	params: {
		cartId
	}
})

export const _putFinanceNotificationStatus = ({notificationId, status}) => axios({
	method: 'put',
	url: `${API_ENDPOINT}/api/admin/finance/notification`,
	withCredentials: true,
	params: {
		notificationId,
		status
	}
})

export const _getAllCreditBalances = ({currency, entityType, entityId }) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/credit/all-credit-balances`,
	withCredentials: true,
	params: {
		currency,
		entityType,
		entityId
	}
})

export const _getEntityCreditInfo = ({ entityType, entityId }) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/credit/credit-info`,
	withCredentials: true,
	params: {
		entityType,
		entityId
	}
})

export const _getEntityIds = ({ entityType, searchTerm }) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/payment-advice/entity-ids`,
	withCredentials: true,
	params: {
		entityType,
		searchTerm
	}
})

export const _getCreditTxns = ({ entityType, entityId }) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/credit/credit-txns`,
	withCredentials: true,
	params: {
		entityType,
		entityId
	}
})
export const _getDebitTxns = ({ entityType, entityId }) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/credit/debit-txns`,
	withCredentials: true,
	params: {
		entityType,
		entityId
	}
})

export const _getEnterpriseSalesAgentData = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/enterprise/sales-agent-overview`,
	withCredentials: true,
})

export const _getSalesAgents = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/users/sales-agents`,
	withCredentials: true,
})


export const _postUpdateSalesAgent = ({ agentId, agentEmail, enterpriseId }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/enterprise/update-sales-agent/${enterpriseId}`,
	withCredentials: true,
	data: {
		agentId, 
		agentEmail,
	}
})

export const _postUpdateSize = ({ size, enterpriseId }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/enterprise/update-size/${enterpriseId}`,
	withCredentials: true,
	data: {
		size
	}
})

export const _postUpdateWallet = ({ wallet, enterpriseId }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/enterprise/update-wallet/${enterpriseId}`,
	withCredentials: true,
	data: {
		wallet
	}
})



export const _postFinanceNotification = ({type, reason,  remarks, cartId, offlineReferenceNumber, refNumber}) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/finance/notification`,
	withCredentials: true,
	data: {
		type,
		reason,
		remarks,
		cartId,
		offlineReferenceNumber,
		refNumber
	}
})

export const _postRemoveAd = (adId) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/ads/remove/${adId}`,
	withCredentials: true
})

export const _postAddVmSupplier = ({supplierId}) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/vm/supplier/add`,
	withCredentials: true,
	data: {
		supplierId
	}
})

export const _postRemoveVmSupplier = ({supplierId}) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/vm/supplier/remove`,
	withCredentials: true,
	data: {
		supplierId
	}
})

export const _postAddVm = ({name,address, enterpriseId, departmentCode}) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/vm/new`,
	withCredentials: true,
	data: {
		name,
		address,
		enterpriseId,
		departmentCode
	}
})

export const _postEditVm = ({vmId, name,address, enterpriseId, departmentCode}) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/vm/edit`,
	withCredentials: true,
	data: {
		vmId,
		name,
		address,
		enterpriseId,
		departmentCode
	}
})

export const _postSetPaymentMethodPaynow = ({cartId}) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/orders/set-as-paynow-order`,
	withCredentials: true,
	data: {
		cartId
	}
})

export const _postPaymentAdvicePaginate = ({ page, limit, entityTypeFilter, verifiedFilter, paymentAdviceNumber_search, entityName_search }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/payment-advice/paginate`,
	withCredentials: true,
	data: {
		page, 
		limit,
		entityTypeFilter,
		verifiedFilter,
		paymentAdviceNumber_search,
		entityName_search
	}
})

export const _postCreditNotePaginate = ({ page, limit, creditedFilter, cartRefNumber_search }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/credit-note/paginate`,
	withCredentials: true,
	data: {
		page, 
		limit,
		creditedFilter,
		cartRefNumber_search
	}
})

export const _postWithdrawCredit = ({ entityType, entityId, currency, amount, paymentMethodId, depositToId }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/credit/withdraw`,
	withCredentials: true,
	data: {
		entityType,
		entityId,
		currency,
		amount,
		paymentMethodId,
		depositToId,
	}
})

export const _postSpendEvent = ({ entityType, entityId, invoiceList }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/credit/spend`,
	withCredentials: true,
	data: {
		entityType, 
		entityId,
		invoiceList
	}
})

export const _postNewPaymentAdvice = ({ entityType, entityId, amount, paymentAdviceNumber }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/payment-advice/new`,
	withCredentials: true,
	data: {
		entityType, 
		entityId,
		amount,
		paymentAdviceNumber
	}
})

export const _putPaymentDetails = ({ mktBaseCurrency, paymentDetailsName, enterpriseId }) => axios({
	method: 'put',
	url: `${API_ENDPOINT}/api/admin/enterprise/eezee-payment-details/${enterpriseId}`,
	withCredentials: true,
	data: {
		mktBaseCurrency,
		paymentDetailsName
	}
})

export const _putPlatformFee = ({ platformFeeActive, platformFee, enterpriseId }) => axios({
	method: 'put',
	url: `${API_ENDPOINT}/api/admin/enterprise/platform-fee/${enterpriseId}`,
	withCredentials: true,
	data: {
		platformFeeActive,
		platformFee
	}
})

export const _putAutoSendArInvoice = ({ autoSendArInvoice, enterpriseId }) => axios({
	method: 'put',
	url: `${API_ENDPOINT}/api/admin/enterprise/auto-send-ar-invoice/${enterpriseId}`,
	withCredentials: true,
	data: {
		autoSendArInvoice,
	}
})

export const _putAutoSendPodCompletion = ({ autoSendPodCompletion, enterpriseId }) => axios({
	method: 'put',
	url: `${API_ENDPOINT}/api/admin/enterprise/auto-send-pod-completion/${enterpriseId}`,
	withCredentials: true,
	data: {
		autoSendPodCompletion,
	}
})

export const _putSendArInvoiceToFinanceEmailOnly = ({ sendArInvoiceToFinanceEmailOnly, enterpriseId }) => axios({
	method: 'put',
	url: `${API_ENDPOINT}/api/admin/enterprise/send-ar-invoice-to-finance-email-only/${enterpriseId}`,
	withCredentials: true,
	data: {
		sendArInvoiceToFinanceEmailOnly,
	}
})

export const _putFinanceEmail = ({ financeEmail, enterpriseId }) => axios({
	method: 'put',
	url: `${API_ENDPOINT}/api/admin/enterprise/finance-email/${enterpriseId}`,
	withCredentials: true,
	data: {
		financeEmail,
	}
})

export const _putQuotationCcEmail = ({ quotationCcEmail, enterpriseId }) => axios({
	method: 'put',
	url: `${API_ENDPOINT}/api/admin/enterprise/quotation-cc-email/${enterpriseId}`,
	withCredentials: true,
	data: {
		quotationCcEmail,
	}
})

export const _putActivateConsolidateArInvoiceFlag = ({
	enterpriseId, 
	consolidateArInvoiceFlagToActivate // `consolidateArInvoiceBySo` OR consolidateArInvoice
}) => axios({
	method: 'put',
	url: `${API_ENDPOINT}/api/admin/enterprise/consolidate-ar-invoice-flags/${enterpriseId}`,
	withCredentials: true,
	data: {
		consolidateArInvoiceFlagToActivate
	}
})

export const _putDeactivateConsolidateArInvoiceFlags = ({
	enterpriseId,
}) => axios({
	method: 'put',
	url: `${API_ENDPOINT}/api/admin/enterprise/consolidate-ar-invoice-flags/deactivate/${enterpriseId}`,
	withCredentials: true,
})

export const _putConsolidateArInvoiceBySo = ({ 
	enterpriseId, 
	consolidateArInvoiceBySo,
}) => axios({
	method: 'put',
	url: `${API_ENDPOINT}/api/admin/enterprise/consolidate-ar-invoice-by-so/${enterpriseId}`,
	withCredentials: true,
	data: {
		consolidateArInvoiceBySo,
	}
})

export const _putConsolidateArInvoice = ({ 
	enterpriseId, 
	consolidateArInvoice,
}) => axios({
	method: 'put',
	url: `${API_ENDPOINT}/api/admin/enterprise/consolidate-ar-invoice/${enterpriseId}`,
	withCredentials: true,
	data: {
		consolidateArInvoice,
	}
})

export const _putBillingCutOffDates = ({ 
	enterpriseId, 
	billingCutOffDates
}) => axios({
	method: 'put',
	url: `${API_ENDPOINT}/api/admin/enterprise/billing-cut-off-dates/${enterpriseId}`,
	withCredentials: true,
	data: {
		billingCutOffDates
	}
})

export const _deletePaymentAdvice = ({paymentAdviceId}) => axios({
	url: `${API_ENDPOINT}/api/admin/payment-advice/${paymentAdviceId}`,
	method: 'delete',
	withCredentials: true
})

export const _putRemarksInternal = ({ deliveryId, remarks }) => axios({
	method: 'put',
	url: `${API_ENDPOINT}/api/admin/delivery/remarks-internal/${deliveryId}`,
	withCredentials: true,
	data: {
		remarks
	}
})

export const _putRemarksExternal = ({ deliveryId, remarks }) => axios({
	method: 'put',
	url: `${API_ENDPOINT}/api/admin/delivery/remarks-external/${deliveryId}`,
	withCredentials: true,
	data: {
		remarks
	}
})

/* PRODUCT PRIME */
export const _getSearchExStock = ({ searchParam }) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/product-ex-stock/search/${searchParam}`,
	withCredentials: true,
})

export const _getExStockData = ({ productId }) => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/product-ex-stock/data/${productId}`,
	withCredentials: true,
})

export const _postAddProductToExStock = ({ productId }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/product-ex-stock/${productId}`,
	withCredentials: true,
})

export const _putRemoveProductFromExStock = ({ productId }) => axios({
	method: 'put',
	url: `${API_ENDPOINT}/api/product-ex-stock/${productId}`,
	withCredentials: true,
})

export const _postPaginateAllExStock = ({page, limit, title_search, supplier_search}) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/product-ex-stock/paginate`,
	withCredentials: true,
	data: {
		page, 
		limit, 
		title_search, 
		supplier_search
	}
})
/* END OF PRODUCT PRIME */

/* THREE P */
export const _getThreePs = () => axios({
	method: 'get',
	url: `${API_ENDPOINT}/api/admin/three-p`,
	withCredentials: true,
});

export const _postThreeP = ({ level, value, parentId }) => axios({
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/three-p`,
	withCredentials: true,
	data: {
		level,
		value,
		parentId
	}
})

export const _putThreeP = ({ id, value }) => axios({
	method: 'put',
	url: `${API_ENDPOINT}/api/admin/three-p/${id}`,
	withCredentials: true,
	data: {
		value
	}
})

export const _deleteThreeP = ({ id }) => axios({
	method: 'delete',
	url: `${API_ENDPOINT}/api/admin/three-p/${id}`,
	withCredentials: true,
})

/* END OF THREE P */

export const IotDeviceService = {

	deleteIotDevice: ( iotDeviceId ) => axios({
		method: "delete",
		withCredentials: true,
		url: `${API_ENDPOINT}/api/admin/iot-devices/${iotDeviceId}`
	}),
	

	getDevices: ( filter = { enterpriseId: "", deviceType: "" }) => axios({
		method: "get",
		url: `${API_ENDPOINT}/api/admin/iot-devices`,
		withCredentials: true,
		params: {
			enterpriseId: filter.enterpriseId, 
			deviceType: filter.deviceType
		}
	}),

	postAddNewDevice: ({ deviceName, deviceType, enterpriseId }) => axios({
		method: "post",
		withCredentials: true,
		url: `${API_ENDPOINT}/api/admin/iot-devices`,
		data: {
			deviceName,
			deviceType,
			enterpriseId
		}
	}),

	postEditIotDevice: ({ enterpriseId, _id, deviceName, deviceType }) => axios({
		url: `${API_ENDPOINT}/api/admin/iot-devices/${_id}`,
		method: "post",
		withCredentials: true,
		data: { 
			enterpriseId, 
			_id, 
			deviceName, 
			deviceType
		}
	}),
	
	LockerService:{

		getBoxes: ( iotDeviceName ) => axios({
			withCredentials: true,
			method: "get",
			url: `${API_ENDPOINT}/api/admin/iot-locker/boxes`,
			params: {
				iotDeviceName
			}
		}),

		postBoxBooking: ( boxBookingData ) => axios({
			withCredentials: true,
			method: "post",
			url: `${API_ENDPOINT}/api/admin/iot-locker/book-locker-boxes`,
			data: {
				boxBookingData
			}
		})
	}

}




export const _getTableChartData = _getPieChartData;

/**
 * TERM CONTRACTS - /api/admin/term-contracts (eezee-server T-135).
 * Responses carry costPrice and the backing supplier: admin only.
 */
// Built per call: src/index.js assigns API_ENDPOINT after this module loads (circular import).
const termContractsUrl = () => `${API_ENDPOINT}/api/admin/term-contracts`;

/* status: active | upcoming | ended | deleted | all (server default active) */
export const _getTermContracts = ({
	enterpriseId,
	status,
	q,
	page,
}) => axios({
	withCredentials: true,
	url: termContractsUrl(),
	params: { enterpriseId: enterpriseId || undefined, status, q: q || undefined, page }
})

export const _getTermContract = ({
	id,
}) => axios({
	withCredentials: true,
	url: `${termContractsUrl()}/${id}`
})

export const _postTermContract = ({
	data,
}) => axios({
	method: 'post',
	withCredentials: true,
	url: termContractsUrl(),
	data
})

export const _putTermContract = ({
	id,
	data,
}) => axios({
	method: 'put',
	withCredentials: true,
	url: `${termContractsUrl()}/${id}`,
	data
})

export const _deleteTermContract = ({
	id,
}) => axios({
	method: 'delete',
	withCredentials: true,
	url: `${termContractsUrl()}/${id}`
})

export const _getTermContractBackingSellers = ({
	q,
}) => axios({
	withCredentials: true,
	url: `${termContractsUrl()}/backing-sellers`,
	params: { q }
})

export const _getTermContractLines = ({
	id,
	page,
	q,
	flag,
	listingSupplierId,
}) => axios({
	withCredentials: true,
	url: `${termContractsUrl()}/${id}/lines`,
	params: { page, q: q || undefined, flag: flag || undefined, listingSupplierId: listingSupplierId || undefined }
})

/* action: setBackingSeller | remove | adjustPricePct; target: { lineIds } | { filter } */
export const _postTermContractLinesBulk = ({
	id,
	action,
	target,
	value,
}) => axios({
	method: 'post',
	withCredentials: true,
	url: `${termContractsUrl()}/${id}/lines/bulk`,
	data: { action, target, value }
})

export const _getTermContractProductPreview = ({
	id,
	productId,
}) => axios({
	withCredentials: true,
	url: `${termContractsUrl()}/${id}/product-preview`,
	params: { productId }
})

/* every line as .xlsx in the upload's layout; header row only when there are none */
export const _getTermContractLinesDownload = ({
	id,
}) => axios({
	withCredentials: true,
	responseType: 'blob',
	url: `${termContractsUrl()}/${id}/lines/download`
})

export const _postTermContractLine = ({
	id,
	data,
}) => axios({
	method: 'post',
	withCredentials: true,
	url: `${termContractsUrl()}/${id}/lines`,
	data
})

export const _putTermContractLine = ({
	id,
	lineId,
	data,
}) => axios({
	method: 'put',
	withCredentials: true,
	url: `${termContractsUrl()}/${id}/lines/${lineId}`,
	data
})

export const _deleteTermContractLine = ({
	id,
	lineId,
}) => axios({
	method: 'delete',
	withCredentials: true,
	url: `${termContractsUrl()}/${id}/lines/${lineId}`
})

/* both uploads take one multipart field, "file" */
const fileForm = ({
	file,
}) => {
	const data = new FormData();
	data.append('file', file);
	return data;
}

export const _postTermContractLinesUpload = ({
	id,
	file,
}) => axios({
	method: 'post',
	withCredentials: true,
	url: `${termContractsUrl()}/${id}/lines/upload`,
	data: fileForm({ file })
})

export const _postTermContractAttachment = ({
	id,
	file,
}) => axios({
	method: 'post',
	withCredentials: true,
	url: `${termContractsUrl()}/${id}/attachments`,
	data: fileForm({ file })
})

/* the bucket is private, so the server streams the file back */
export const _getTermContractAttachment = ({
	id,
	attachmentId,
}) => axios({
	withCredentials: true,
	responseType: 'blob',
	url: `${termContractsUrl()}/${id}/attachments/${attachmentId}`
})

export const _deleteTermContractAttachment = ({
	id,
	attachmentId,
}) => axios({
	method: 'delete',
	withCredentials: true,
	url: `${termContractsUrl()}/${id}/attachments/${attachmentId}`
})

/* grouped per upload / bulk action; type: price | lines | details | documents */
export const _getTermContractLogs = ({
	id,
	page,
	type,
	userId,
}) => axios({
	withCredentials: true,
	url: `${termContractsUrl()}/${id}/logs`,
	params: { page, type: type || undefined, userId: userId || undefined }
})

export const _getTermContractLogBatch = ({
	id,
	batchId,
}) => axios({
	withCredentials: true,
	url: `${termContractsUrl()}/${id}/logs/${batchId}`
})

/**
 * SUPPLIER PRICE LISTS - /api/admin/supplier-price-lists (eezee-server T-214).
 * One list per supplier per market (mktBaseCurrency, added by the interceptor). Responses carry cost prices: admin only.
 */
const supplierPriceListsUrl = () => `${API_ENDPOINT}/api/admin/supplier-price-lists`;

export const _getSupplierPriceLists = ({
	sellerId,
	q,
	page,
}) => axios({
	withCredentials: true,
	url: supplierPriceListsUrl(),
	params: { sellerId: sellerId || undefined, q: q || undefined, page }
})

/* IST seller orgs: { sellers: [{ id, companyName, status }] } */
export const _getSupplierPriceListSellers = ({
	q,
}) => axios({
	withCredentials: true,
	url: `${supplierPriceListsUrl()}/sellers`,
	params: { q }
})

export const _getSupplierPriceList = ({
	id,
}) => axios({
	withCredentials: true,
	url: `${supplierPriceListsUrl()}/${id}`
})

/* { sellerId, ethSupplierId?, notes? }; 409 when the supplier already has a list in this market */
export const _postSupplierPriceList = ({
	data,
}) => axios({
	method: 'post',
	withCredentials: true,
	url: supplierPriceListsUrl(),
	data
})

/* { ethSupplierId?, notes? } */
export const _putSupplierPriceList = ({
	id,
	data,
}) => axios({
	method: 'put',
	withCredentials: true,
	url: `${supplierPriceListsUrl()}/${id}`,
	data
})

export const _deleteSupplierPriceList = ({
	id,
}) => axios({
	method: 'delete',
	withCredentials: true,
	url: `${supplierPriceListsUrl()}/${id}`
})

/* filter: q, linked, expired, dropped (true|false), priceChangedWithinDays, sort (title | lastPriceChangeAt) */
export const _getSupplierPriceListLines = ({
	id,
	page,
	filter,
}) => axios({
	withCredentials: true,
	url: `${supplierPriceListsUrl()}/${id}/lines`,
	params: { page, ...filter }
})

export const _postSupplierPriceListLine = ({
	id,
	data,
}) => axios({
	method: 'post',
	withCredentials: true,
	url: `${supplierPriceListsUrl()}/${id}/lines`,
	data
})

/* partial; productId sets (an id) or clears (null) a manual link */
export const _putSupplierPriceListLine = ({
	id,
	lineId,
	data,
}) => axios({
	method: 'put',
	withCredentials: true,
	url: `${supplierPriceListsUrl()}/${id}/lines/${lineId}`,
	data
})

export const _deleteSupplierPriceListLine = ({
	id,
	lineId,
}) => axios({
	method: 'delete',
	withCredentials: true,
	url: `${supplierPriceListsUrl()}/${id}/lines/${lineId}`
})

/* action: remove | setValidTo; target: { lineIds } | { filter } */
export const _postSupplierPriceListLinesBulk = ({
	id,
	action,
	target,
	value,
}) => axios({
	method: 'post',
	withCredentials: true,
	url: `${supplierPriceListsUrl()}/${id}/lines/bulk`,
	data: { action, target, value }
})

/* every live line as the template; header only when there are none */
export const _getSupplierPriceListLinesDownload = ({
	id,
}) => axios({
	withCredentials: true,
	responseType: 'blob',
	url: `${supplierPriceListsUrl()}/${id}/lines/download`
})

/* the filled template (file), the upload's fields and, optionally, the supplier's own file */
export const _postSupplierPriceListLinesUpload = ({
	id,
	file,
	sourceFile,
	fileDate,
	validTo,
	fullList,
	sourceRef,
}) => {
	const data = fileForm({ file });
	if (sourceFile) data.append('sourceFile', sourceFile);
	data.append('fileDate', fileDate);
	data.append('validTo', validTo);
	data.append('fullList', fullList ? 'true' : 'false');
	if (sourceRef) data.append('sourceRef', sourceRef);
	return axios({
		method: 'post',
		withCredentials: true,
		url: `${supplierPriceListsUrl()}/${id}/lines/upload`,
		data
	});
}

export const _getSupplierPriceListUploads = ({
	id,
}) => axios({
	withCredentials: true,
	url: `${supplierPriceListsUrl()}/${id}/uploads`
})

/* which: source (the supplier's file) | template */
export const _getSupplierPriceListUploadFile = ({
	id,
	uploadId,
	which,
}) => axios({
	withCredentials: true,
	responseType: 'blob',
	url: `${supplierPriceListsUrl()}/${id}/uploads/${uploadId}/file`,
	params: { which }
})

/* AI import, step 1: files → { importToken, rows, conflicts, warnings, suggested, looksLikeQuotation, mappings }. Saves no line. */
export const _postSupplierPriceListImportParse = ({
	id,
	files,
}) => {
	const data = new FormData();
	files.forEach(file => data.append('file', file));
	return axios({
		method: 'post',
		withCredentials: true,
		url: `${supplierPriceListsUrl()}/${id}/import/parse`,
		data
	});
}

/* AI import, step 2: { importToken, rows, fileDate, validTo, fullList, sourceRef } → the template upload's response */
export const _postSupplierPriceListImportCommit = ({
	id,
	data,
}) => axios({
	method: 'post',
	withCredentials: true,
	url: `${supplierPriceListsUrl()}/${id}/import/commit`,
	data
})



// WEBPACK FOOTER //
// ./src/services/index.js